import React, { useEffect, useState, useRef } from 'react';
import { getToken } from "../../../src/utils/tokenUtils";
import axios from 'axios';
import Drawer from '../../components/UI/Drawer';
import DeleteButton from "../../components/UI/AlertDialog";
import Notification from "../../components/UI/Notification";
import ReactPaginate from 'react-paginate';
import { User, Briefcase, Edit3, Save, X, Download, FileText, GraduationCap, CreditCard, FileCheck, MessageCircle, MapPin, Phone, MoreVertical } from 'lucide-react';
import QRCode from "react-qr-code";
import CustomModal from '../../components/UI/CustomModal';
import html2canvas from "html2canvas";
import { Upload, CheckCircle, AlertCircle, MessageSquare } from "lucide-react";
import ExportToExcel from '../../components/UI/ExportToExcel';
import PdfPreviewModal from '../../components/UI/PdfPreviewModal';

const OnBoardingFormResponsePage = ({ formId = null }) => {
    const fileInputRefs = useRef({});
    const [formResponses, setFormResponses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingSaveChanges, setLoadingSaveChanges] = useState(false);
    const [error, setError] = useState('');
    const token = getToken();
    const [selectedSubmission, setSelectedSubmission] = useState(null);
    const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
    const [actionType, setActionType] = useState('');
    const [approvalComment, setApprovalComment] = useState('');
    const [processToJoin, setProcessToJoin] = useState('');
    const [employee_id_by_hr, setEmployeeIDByHr] = useState('');
    const [employee_is_bfl, setEmployeeIsBFL] = useState('');	
    const [officialEmail, setOfficialEmail] = useState('');
    // const [designation, setDesignation] = useState('');
    const [department, setDepartment] = useState('');
    const [probationPeriod, setProbationPeriod] = useState('');
    const [noticePeriod, setNoticePeriod] = useState('');
    const [reportingTo, setReportingTo] = useState('');
    const [employeeOfferLetter, setEmployeeOfferLetter] = useState(null);
    const [nda, setNda] = useState(null);
    const [selfDeclaration, setSelfDeclaration] = useState(null);
    const [concernForm, setConcernForm] = useState(null);
    const [codeOfConduct, setCodeOfConduct] = useState(null);
    const [backgroundVerification, setBackgroundVerification] = useState(null);
    const [inductionAcknowledgment, setInductionAcknowledgment] = useState(null);
    const [anyOtherDocuments, setAnyOtherDocuments] = useState(null);
    const [infosecAcknowledgment, setInfosecAcknowledgment] = useState(null);
    const [poshAcknowledgment, setPoshAcknowledgment] = useState(null);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [notification, setNotification] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [isFiltering, setIsFiltering] = useState(false);
    const [isApproverModalOpen, setIsApproverModalOpen] = useState(false);
    const [approverDetails, setApproverDetails] = useState(null);   
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        perPage: 15,
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState('personal');
    const [isOpen, setIsOpen] = useState(false);
    // const link = `${window.location.origin}/on-boarding/`;
    const [showModal, setShowModal] = useState(false);
    const qrContainerRef = useRef(null);
    const qrValue = `${window.location.origin}/on-boarding/`; 
    // filter
    const [searchQuery, setSearchQuery] = useState("");
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [activeFilters, setActiveFilters] = useState({});
    const [filteredData, setFilteredData] = useState(formResponses);
    const [tempFilters, setTempFilters] = useState({});

    // // console.log(selectedSubmission);
    const [openCommentId, setOpenCommentId] = useState(null);
    const [commentSubmission, setCommentSubmission] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({
        uan_number: '',
        esic_number: '',
        pan_number: '',
        aadhar_number: '',
    });

    // State for file preview modal
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [downloadUrl, setDownloadUrl] = useState(null);



    const [isEditMode, setIsEditMode] = useState(false);
    const [originalData, setOriginalData] = useState();
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [dropdownPosition, setDropdownPosition] = useState('bottom');

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (openDropdownId && !event.target.closest('.dropdown-container')) {
                setOpenDropdownId(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdownId]);

    // Function to determine dropdown position
    const handleDropdownToggle = (submissionId, event) => {
        if (openDropdownId === submissionId) {
            setOpenDropdownId(null);
        } else {
            const button = event.currentTarget;
            const rect = button.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const dropdownHeight = 200; // Approximate dropdown height
            
            // Check if there's enough space below
            const spaceBelow = viewportHeight - rect.bottom;
            const spaceAbove = rect.top;
            
            if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
                setDropdownPosition('top');
            } else {
                setDropdownPosition('bottom');
            }
            
            setOpenDropdownId(submissionId);
        }
    };

    // console.log("originaldata: ", originalData)
    
    // toggle edit
    const handleEditToggle = () => {
        if (isEditMode) {
        // Save changes
        setIsEditMode(false);
        } else {
        // Enter edit mode - save current state as original data
        setOriginalData(selectedSubmission);
        setIsEditMode(true);
        }
    };

    // toggle edit
    const handleCancelEdit = () => {
        setSelectedSubmission(originalData);
        setFieldErrors({});
        // setIsDrawerOpen(false);
        setIsEditMode(false);
    };

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFilterChange = (field, value) => {
        setActiveFilters(prev => ({
        ...prev,
        [field]: value
        }));
    };

    const clearFilters = () => {
        setActiveFilters({});
        setSearchQuery("");
    };

    const clearFilterByKey = (key) => {
        const updatedFilters = { ...activeFilters };
        delete updatedFilters[key];
        setActiveFilters(updatedFilters);
    };

    // Define the filterable columns based on your table structure
    const filterableColumns = [
        { field: "created_at", label: "Date" },
        // { field: "employee_id", label: "EMP ID" },
        { field: "full_name", label: "Candidate Name" },
        { field: "email", label: "Email" },
        { field: "contact_number", label: "Contact Number" },
        { field: "approval_status", label: "Status" }
    ];

    useEffect(() => {
    if (showFilterMenu) {
        setTempFilters(activeFilters);
    }
    }, [showFilterMenu]);

    useEffect(() => {
        fetchResponses();
    }, [token, formId]);

    useEffect(() => {
        setFilteredData(formResponses);
    }, [formResponses]);

    useEffect(() => {
        // Apply both search query and filters
        let result = formResponses;

        // Apply search query filtering
        if (searchQuery) {
        const lowercasedQuery = searchQuery.toLowerCase();
        result = result.filter((item) => {
            // Search across all relevant fields
            return (
            // (item.employee_id?.toString().toLowerCase().includes(lowercasedQuery)) ||
            (item.full_name?.toLowerCase().includes(lowercasedQuery)) ||
            (item.email?.toLowerCase().includes(lowercasedQuery)) ||
            (item.contact_number?.toString().toLowerCase().includes(lowercasedQuery)) ||
            (item.approval_status?.toLowerCase().includes(lowercasedQuery))
            );
        });
        }

        // Apply column-specific filters
        Object.entries(activeFilters).forEach(([field, filterValue]) => {
        if (filterValue) {
            result = result.filter(item => {
            const value = item[field];
            if (field === 'created_at' && value) {
                // Date filtering
                const itemDate = new Date(value);
                const day = String(itemDate.getDate()).padStart(2, '0');
                const month = String(itemDate.getMonth() + 1).padStart(2, '0');
                const year = itemDate.getFullYear();
                const formattedDate = `${day}-${month}-${year}`;
                
                return formattedDate.includes(filterValue);
            } else {
                // Standard string filtering
                return value?.toString().toLowerCase().includes(filterValue.toLowerCase());
            }
            });
        }
        });

        const filteringNow = searchQuery.length > 0 || Object.values(activeFilters).some(v => !!v);
        setIsFiltering(filteringNow);
        setFilteredData(result);
    }, [searchQuery, activeFilters, formResponses]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [activeTab]);

    const tabs = [
        { id: 'personal', label: 'Personal Info', icon: <User className="w-4 h-4" /> },
        { id: 'employment', label: 'Employment', icon: <Briefcase className="w-4 h-4" /> },
        { id: 'documents', label: 'Documents', icon: <FileText className="w-4 h-4" /> },
        { id: 'education', label: 'Education', icon: <GraduationCap className="w-4 h-4" /> },
        { id: 'bankDetails', label: 'Bank Details', icon: <CreditCard className="w-4 h-4" /> },
        { id: 'additional', label: 'Additional', icon: <FileCheck className="w-4 h-4" /> },
        { id: 'extra', label: 'Feedback', icon: <MessageCircle className="w-4 h-4" /> }

    ];

    // Download QR code as image
    const handleDownload = async () => {
        if (!qrContainerRef.current) return;

        const canvas = await html2canvas(qrContainerRef.current, {
        backgroundColor: "#ffffff", // ensures a white background
        useCORS: true, // helps with SVG rendering
        });

        const dataUrl = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "qr-code.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // fetch form responses
    const fetchResponses = async (page = 1) => {
        try {
            const endpoint = formId
            ? `https://hrmsnew.prepstripe.com/api/onboarding-form/${formId}`
            : `https://hrmsnew.prepstripe.com/api/onboarding-form?page=${page}`;
            const res = await axios.get(endpoint, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            });
            setFormResponses(res.data.data.data || []);
            setPagination({
                currentPage: res.data?.data?.current_page || 1,
                totalPages: res.data?.data?.last_page || 1,
                totalItems: res.data?.data?.total || 0,
                perPage: res.data?.data?.per_page || 15,
            });
        } catch (err) {
            setError('Failed to load responses. Please try again.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // Update function
    const handleUpdate = async () => {
        try {

            setLoadingSaveChanges(true)

            // Validate critical fields before submitting
            const requiredKeys = ['full_name', 'email', 'contact_number', 'date_of_birth', 'date_of_joining', 'blood_group', 'uan_number', 'esic_number', 'pan_number', 'aadhar_number'];

            let hasError = false;
            const newErrors = { ...fieldErrors };

            requiredKeys.forEach((key) => {
            const value = selectedSubmission[key]?.trim();
            if (!value) {
                newErrors[key] = `${key.replace('_', ' ').toUpperCase()} is required`;
                hasError = true;
            } else {
                const isNA = value.toLowerCase() === 'na';
                if (key === 'uan_number' && !isNA && !/^\d{12}$/.test(value)) {
                newErrors[key] = 'UAN must be 12 digits or "NA"';
                hasError = true;
                }
                if (key === 'esic_number' && !isNA && !/^\d{10}$/.test(value)) {
                newErrors[key] = 'ESIC must be 10 digits or "NA"';
                hasError = true;
                }
                if (key === 'aadhar_number' && !/^\d{12}$/.test(value)) {
                newErrors[key] = 'Aadhar must be exactly 12 digits';
                hasError = true;
                }
                if (
                key === 'pan_number' &&
                !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value.toUpperCase())
                ) {
                newErrors[key] = 'PAN format is invalid (e.g., ABCDE1234F)';
                hasError = true;
                }
            }
            });

            if (hasError) {
            setFieldErrors(newErrors);
            // setNotification('Please fix the highlighted errors before updating.');
            setNotification({
                message: 'Please fix the highlighted errors before updating.',
                type: "error"
            });
            setLoadingSaveChanges(false)
            setIsEditMode(false)
            return; // stop execution
            }   

            const formData = new FormData();
      
            // Helper to format date to d/m/Y
            const formatDateToDMY = (isoDate) => {
                if (!isoDate) return '';
                const date = new Date(isoDate);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            };
      
            // Append text fields
            Object.entries(selectedSubmission).forEach(([key, value]) => {
                if (
                    typeof value !== 'object' &&
                    value !== null &&
                    key !== 'id'
                    ) {
                    if (key === 'date_of_joining' || key === 'date_of_birth') {
                            formData.append(key, formatDateToDMY(value));
                        } else {
                            formData.append(key, value);
                    }
                }
            });
      
            // Append files from nested groups
            ['documents', 'educational_documents', 'bank_details', 'additional_documents'].forEach(
                (groupKey) => {
                const group = selectedSubmission[groupKey];
                if (group && typeof group === 'object') {
                    Object.entries(group).forEach(([docKey, docValue]) => {
                    if (docValue?.file) {
                        formData.append(`${docKey}`, docValue.file);
                    }
                    });
                }
                }
            );

            // console.log("formdata to be pass: ", formData)
      
            const res = await axios.post(
                `https://hrmsnew.prepstripe.com/api/onboarding-form/${selectedSubmission.id}`,
                formData,
                {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
                }
            );
          
            // console.log('res.data:', res.data);
            
            // Update state locally
            const updatedData = res.data.data;
            setFormResponses((prev) =>
                prev.map((item) =>
                item.id === selectedSubmission.id ? updatedData : item
                )
            );

            // Update selectedSubmission and originalData with the new data
            setSelectedSubmission(updatedData);
            setOriginalData(updatedData);

            setLoadingSaveChanges(false)

            // setNotification('Response updated successfully!');
            setNotification({
                message: "Response updated successfully!",
                type: "success"
            });

            // Reset file inputs after successful upload
            ['documents', 'educational_documents', 'bank_details', 'additional_documents'].forEach(
                (groupKey) => {
                const group = selectedSubmission[groupKey];
                if (group && typeof group === 'object') {
                    Object.keys(group).forEach((docKey) => {
                    // Reset file from state
                    setSelectedSubmission((prev) => ({
                        ...prev,
                        [groupKey]: {
                        ...prev[groupKey],
                        [docKey]: {
                            ...prev[groupKey][docKey],
                            file: null,
                        },
                        },
                    }));
            
                    // Reset input element
                    const inputRef = fileInputRefs.current[`${groupKey}_${docKey}`];
                    if (inputRef) inputRef.value = '';
                    });
                }
                }
            );
            
            // alert('Submission updated successfully!');
            // setIsDrawerOpen(false);
            setIsEditMode(false)
            } catch (err) {
            // console.log("this is error: ", err)
            setLoadingSaveChanges(false)
            // setNotification((err.response?.data?.message || "Unknown error"));
            setNotification({
                message: `${err.response?.data?.message || "Unknown error"}`,
                type: "error"
            });
            // console.error('Error updating:', err);
        }
    };
      
    // Delete function
    const handleDelete = async (id) => {
        // console.log("Deleting submission with ID:", id);
        const confirmDelete = window.confirm("Are you sure you want to delete this submission?");
        if (!confirmDelete) return;
        // console.log("Deleting submission with ID:", id);
        try {
            await axios.delete(`https://hrmsnew.prepstripe.com/api/onboarding-form/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            });
        
            // Update local state after deletion
            setFormResponses((prev) => prev.filter((item) => item.id !== id));
            
            // setNotification("Submission deleted successfully!");
            setNotification({
                message: "Submission deleted successfully!",
                type: "success"
            });
            // alert("Submission deleted successfully!");
            setIsDrawerOpen(false);
        } catch (err) {
            // console.error("Error deleting submission:", err);
            // setNotification("Failed to delete submission");
            setNotification({
                message: "Failed to delete submission",
                type: "error"
            });
            // alert("Failed to delete submission");
        }
    };

    // open approver modal
    const openApprovalModal = (submission, type) => {
        // console.log("Opening approval modal for submission:", submission, "and type: ", type);
        setSelectedSubmission(submission);
        setActionType(type);
        setIsApprovalModalOpen(true);
        setApprovalComment('');
    };
    
    // close approver modal
    const closeApprovalModal = () => {
        setIsApprovalModalOpen(false);
        setApprovalComment('');
        setErrors({});
        setApprovalComment('')
        setNoticePeriod('')
        setProbationPeriod('')
        setNoticePeriod('')
        setOfficialEmail('')
        setReportingTo('')
        setBackgroundVerification('')
        setCodeOfConduct('')
        setConcernForm('')
        setDepartment('')
        setEmployeeIDByHr('')
        setEmployeeIsBFL('')
        setEmployeeOfferLetter('')
        setInductionAcknowledgment('')
        setAnyOtherDocuments(null)
        setInfosecAcknowledgment('')
        setPoshAcknowledgment('')
        setProcessToJoin('')
        setNda(null)
    };

    const allowedMimeTypes = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
    ];

    const maxFileSize = 1 * 1024 * 1024; // 2MB in bytes

    const validateFile = (file, fieldName, errors) => {
        if (!file) return;

        if (!allowedMimeTypes.includes(file.type)) {
            errors[fieldName] = "Only PDF, JPEG, JPG, PNG, DOC, and DOCX files are allowed.";
        } else if (file.size > maxFileSize) {
            errors[fieldName] = "File size must be less than 1MB.";
        }
    };


    // approve function
    const handleApproval = async () => {
        if (!selectedSubmission) return;

        const formData = new FormData();

        // Validation
        const newErrors = {};
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // const textOnlyPattern = /^[A-Za-z\s]+$/;
        const textOnlyPattern = /^[A-Za-z\s\.\,\-\'\&\#\@\(\)\/]+$/;
        const numberOnlyPattern = /^\d+$/;

        if (actionType === 'rejected') {
            if (!approvalComment.trim()) {
            newErrors.approvalComment = "Comment is required for rejection.";
            setErrors(newErrors);
            return;
            }

            // formData.append('approval_status', 'rejected');
            // formData.append('hr_comments', approvalComment);

        } else {

            if (!employee_is_bfl) {
                newErrors.employee_is_bfl = "Please select if the employee is a BFL employee or not.";
            }

            // Employee ID validation
            if (!employee_id_by_hr.trim()) {
            newErrors.employee_id_by_hr = "Employee ID is required.";
            } else if (!numberOnlyPattern.test(employee_id_by_hr)) {
            newErrors.employee_id_by_hr = "Employee ID must be a number.";
            }

            // Employee Process Validation
            if (!processToJoin.trim()) {
            newErrors.processToJoin = "Employee Process is required.";
            } else if (!textOnlyPattern.test(processToJoin)) {
            newErrors.processToJoin = "Employee Process field should not contain numbers.";
            }
        
            // Email validation
            if (!officialEmail.trim()) {
            newErrors.officialEmail = "Official email is required.";
            } else if (!emailPattern.test(officialEmail)) {
            newErrors.officialEmail = "Please enter a valid email address.";
            }
        
            // Designation validation
            // if (!designation.trim()) {
            //   newErrors.designation = "Designation is required.";
            // } else if (!textOnlyPattern.test(designation)) {
            //   newErrors.designation = "Designation should not contain numbers.";
            // }

            // Department validation
            if (!department.trim()) {
            newErrors.department = "Department is required.";
            } else if (!textOnlyPattern.test(department)) {
            newErrors.department = "Designation should not contain numbers.";
            }
        
            // Probation period validation
            if (!probationPeriod.trim()) {
                newErrors.probationPeriod = "Probation period is required.";
            } else if (!numberOnlyPattern.test(probationPeriod)) {
                newErrors.probationPeriod = "Probation period must be a number.";
            } else if (parseInt(probationPeriod) < 1 || parseInt(probationPeriod) > 12) {
                newErrors.probationPeriod = "Enter a valid month between 1 and 12.";
            }
        
            // Notice period validation
            if (!noticePeriod.trim()) {
                newErrors.noticePeriod = "Notice period is required.";
            } else if (!numberOnlyPattern.test(noticePeriod)) {
                newErrors.noticePeriod = "Notice period must be a number.";
            } else if (parseInt(noticePeriod) < 1 || parseInt(noticePeriod) > 90) {
                newErrors.noticePeriod = "Enter a valid number of days between 1 and 90.";
            }
        
            // Reporting To validation
            if (!reportingTo.trim()) {
            newErrors.reportingTo = "Reporting To is required.";
            } else if (!textOnlyPattern.test(reportingTo)) {
            newErrors.reportingTo = "Reporting To must contain only letters.";
            }
        
            // Approval Comment validation
            if (!approvalComment.trim()) {
            newErrors.approvalComment = "Comments are required.";
            } else if (!textOnlyPattern.test(approvalComment)) {
            newErrors.approvalComment = "Comments must contain only letters.";
            }

            // File validations
            if (!employeeOfferLetter || employeeOfferLetter.length === 0) {
            newErrors.employeeOfferLetter = "Employee Offer Letter is required.";
            } else {
            validateFile(employeeOfferLetter[0], 'employeeOfferLetter', newErrors);
            }

            // File validations
            if (!nda || nda.length === 0) {
                newErrors.nda = "NDA is required.";
                } else {
                validateFile(nda[0], 'nda', newErrors);
            }

            // file validations
            // if (!inductionAcknowledgment || inductionAcknowledgment.length === 0) {
            // newErrors.inductionAcknowledgment = "NDA is required.";
            // } else {
            // validateFile(inductionAcknowledgment[0], 'inductionAcknowledgment', newErrors);
            // }

            // if (!infosecAcknowledgment || infosecAcknowledgment.length === 0) {
            // newErrors.infosecAcknowledgment = "Infosec Acknowledgment is required.";
            // } else {
            // validateFile(infosecAcknowledgment[0], 'infosecAcknowledgment', newErrors);
            // }

            // if (!poshAcknowledgment || poshAcknowledgment.length === 0) {
            // newErrors.poshAcknowledgment = "Posh Acknowledgment is required.";
            // } else {
            // validateFile(poshAcknowledgment[0], 'poshAcknowledgment', newErrors);
            // }

            // File validations (only if employee_is_bfl is 'yes')
            if (employee_is_bfl === 'yes') {
                if (!nda) {
                    newErrors.nda = "NDA document is required.";
                }
                if (!selfDeclaration) {
                    newErrors.selfDeclaration = "Self Declaration is required.";
                }
                if (!concernForm) {
                    newErrors.concernForm = "Concern Form is required.";
                }
                if (!codeOfConduct) {
                    newErrors.codeOfConduct = "Code of Conduct is required.";
                }
                if (!backgroundVerification) {
                    newErrors.backgroundVerification = "Background Verification is required.";
                }
                if (!inductionAcknowledgment) {
                    newErrors.inductionAcknowledgment = "Induction Acknowledgment is required.";
                }
                if (!infosecAcknowledgment) {
                    newErrors.infosecAcknowledgment = "Infosec Acknowledgment is required.";
                }
                if (!poshAcknowledgment) {
                    newErrors.poshAcknowledgment = "POSH Acknowledgment is required.";
                }
            }

        
            // If any errors exist, stop here
            if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
            }      

        }
      
        setErrors({});
        
        setIsSubmitting(true);
        
        try {
            
            if (actionType === 'rejected') {

                formData.append('approval_status', 'rejected');
                formData.append('hr_comments', approvalComment);

            } else {

                // Text fields
                formData.append('approval_status', 'approved');
                formData.append('hr_comments', approvalComment);

                formData.append('employee_id_by_hr', employee_id_by_hr);
                formData.append('employee_is_bfl', employee_is_bfl);
                formData.append('employee_official_email', officialEmail);
                formData.append('employee_department', department);
                formData.append('employee_process', processToJoin);
                // formData.append('employee_designation', designation);
                formData.append('employee_probation_period', probationPeriod);
                formData.append('employee_notice_period', noticePeriod);
                formData.append('employee_reporting_to', reportingTo);

                // File fields (add only if selected)
                // console.log("employeeOfferLetter", employeeOfferLetter[0])
                if (employeeOfferLetter) formData.append('employee_offer_letter', employeeOfferLetter[0]);
                if (nda) formData.append('nda', nda[0]);
                if (selfDeclaration) formData.append('self_declaration', selfDeclaration[0]);
                if (concernForm) formData.append('concern_form', concernForm[0]);
                if (codeOfConduct) formData.append('code_of_conduct', codeOfConduct[0]);
                if (backgroundVerification) formData.append('background_verification', backgroundVerification[0]);
                if (inductionAcknowledgment) formData.append('induction_acknowledgment', inductionAcknowledgment[0]);
    if (anyOtherDocuments && anyOtherDocuments.length > 0) {
      for (let i = 0; i < anyOtherDocuments.length; i++) {
        formData.append(`other_documents[${i}]`, anyOtherDocuments[i]);
      }
    }
                if (infosecAcknowledgment) formData.append('infosec_acknowledgment', infosecAcknowledgment[0]);
                if (poshAcknowledgment) formData.append('posh_acknowledgment', poshAcknowledgment[0]);

            }

            // console.log("formData: ", formData)

            const response = await axios.post(`https://hrmsnew.prepstripe.com/api/onboarding-form/${selectedSubmission.id}/approval`, 
            formData,
            {
                headers: {
                'Authorization': `Bearer ${token}`,
                }
            }
            );
          
        setFormResponses(formResponses.map(item =>
            item.id === selectedSubmission.id
              ? {
                  ...item,
                  approval_status: actionType,
                  approved_by: response.data["approved_by"],
                  hr_comments: approvalComment,
                  actioned_at: response.data["actioned_at"],
                  action_day: response.data["action_day"],

                  ...(actionType === 'approved' && {
                    approver_designation: response.data['approver_designation'],
                    approved_by: response.data["approved_by"],

                    employee_official_email: response.data["employee_official_email"],
                    //   employee_designation: response.data["employee_designation"],
                    employee_probation_period: response.data["employee_probation_period"],
                    employee_notice_period: response.data["employee_notice_period"],
                    employee_reporting_to: response.data["employee_reporting_to"],

                    employee_department: response.data['employee_department'],
                    employee_designation: response.data['employee_designation'],
                    employee_id_by_hr: response.data['employee_id_by_hr'],
                    employee_is_bfl: response.data['employee_is_bfl'],
                    employee_process: response.data['employee_process'],

                    employee_offer_letter: response.data['employee_offer_letter'],

                    bfl_documents: response.data['bfl_documents']
                  }),
                }
              : item
          ));

          setApprovalComment('')
          setNoticePeriod('')
          setProbationPeriod('')
          setNoticePeriod('')
          setOfficialEmail('')
          setReportingTo('')
          setBackgroundVerification('')
          setCodeOfConduct('')
          setConcernForm('')
          setDepartment('')
          setEmployeeIDByHr('')
          setEmployeeIsBFL('')
          setEmployeeOfferLetter('')
          setInductionAcknowledgment('')
          setInfosecAcknowledgment('')
          setPoshAcknowledgment('')
          setProcessToJoin('')
          

        // // console.log("response afte approved: ", response.data)

        // // console.log("approver details before set", approverDetails)


        // // ✅ Update approverDetails for modal
        // setApproverDetails({
        //     approved_by: response.data["Approved By"],
        //     hr_comments: response.data["Comments"],
        //     actioned_at: response.data["actioned_at"],
        //     action_day: response.data["action_day"],
        // });
          
        // // console.log("approver details after set: ", approverDetails)
          
        // Show success notification or toast here
        // setNotification(
        //     `Onboarding form ${actionType === 'approved' ? 'approved' : 'rejected'} successfully`
        // );
        setNotification({
            message: `Onboarding form ${actionType === 'approved' ? 'approved' : 'rejected'} successfully`,
            type: "success"
        });
        closeApprovalModal();
        //   alert("Onboarding form approved successfully");
        } catch (error) {
        //   console.error("Error approving form:", error);
            // setNotification(`Failed to ${actionType}: ${error.response?.data?.message || "Unknown error"}`);
            setNotification({
                message: `Failed to ${actionType}: ${error.response?.data?.message || "Unknown error"}`,
                type: "error"
            });
        //   alert("Failed to approve: " + (error.response?.data?.message || "Unknown error"));
        } finally {
          setIsSubmitting(false);
        //   closeApprovalModal();
        }
    };
    
    // Format the date string to a more readable format
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString();
    };

    const formatDateForInput = (dateStr) => {
        return dateStr ? dateStr.split('T')[0] : '';
    };
      
    // pagination - page change
    const handlePageChange = (newPage) => {
        setLoading(true);
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setCurrentPage(newPage);
            fetchResponses(newPage);
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        const filtering = value !== '';
        setIsFiltering(filtering);
      
        if (!filtering) {
          // Search cleared, restore current page's data
          handlePageChange(currentPage); // fetchResponses will be called inside
        }
    };

    // const filteredData = formResponses.filter(submission =>
    // `${submission.full_name} ${submission.email} ${submission.contact_number} ${submission.approval_status}`
    //     .toLowerCase()
    //     .includes(searchTerm.toLowerCase())
    // );
    
    // Document configuration for cleaner rendering
    const documents = [
        { id: "nda", label: "NDA", state: nda, setState: setNda, error: errors.nda },
        { id: "selfDeclaration", label: "Self Declaration", state: selfDeclaration, setState: setSelfDeclaration, error: errors.selfDeclaration },
        { id: "concernForm", label: "Concern Form", state: concernForm, setState: setConcernForm, error: errors.concernForm },
        { id: "codeOfConduct", label: "Code of Conduct", state: codeOfConduct, setState: setCodeOfConduct, error: errors.codeOfConduct },
        { id: "backgroundVerification", label: "Background Verification", state: backgroundVerification, setState: setBackgroundVerification, error: errors.backgroundVerification },
        { id: "inductionAcknowledgment", label: "Induction Acknowledgment", state: inductionAcknowledgment, setState: setInductionAcknowledgment, error: errors.inductionAcknowledgment },
        { id: "infosecAcknowledgment", label: "Infosec Acknowledgment", state: infosecAcknowledgment, setState: setInfosecAcknowledgment, error: errors.infosecAcknowledgment },
        { id: "poshAcknowledgment", label: "Posh Acknowledgment", state: poshAcknowledgment, setState: setPoshAcknowledgment, error: errors.poshAcknowledgment }
    ];
    
    // // File upload handler
    // const handleFileChange = (setter) => (e) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //     setter(e.target.files);
    //     }
    // };
    
    const handleFileChange = (setter) => (e) => {
        const file = e.target.files?.[0];

        if (!file) return;

        // ✅ File type check
        if (!allowedMimeTypes.includes(file.type)) {
            alert("Only PDF, JPEG, JPG, PNG, DOC, and DOCX files are allowed.");
            e.target.value = ""; // Clear the invalid file
            setter(null);        // Clear the state
            return;
        }

        // ✅ File size check (1 MB)
        const maxSizeInBytes = 1 * 1024 * 1024;
        if (file.size > maxSizeInBytes) {
            alert('File size must be less than or equal to 1 MB.');
            e.target.value = ''; // Clear large file
            return;
        }

        setter(e.target.files); // Accept the valid file
    };

    // Convert "20-05-2025" to "2025-05-20"
    function formatToInputDate(value) {
    if (!value) return "";
    const [day, month, year] = value.split("-");
    if (!day || !month || !year) return "";
    return `${year}-${month}-${day}`;
    }

    // Convert "2025-05-20" to "20-05-2025"
    function formatToDisplayDate(value) {
    if (!value) return "";
    const [year, month, day] = value.split("-");
    if (!day || !month || !year) return "";
    return `${day}-${month}-${year}`;
    }

    const hasTempFilters = Object.values(tempFilters).some((val) => val !== "");

    return (
        <div className="px-3 py-2 bg-white dark:bg-black shadow-lg rounded-lg">
            
            {/* notification */}
            {notification && (
                <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />
            )}

            {/* title and on-boarding form qr code */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
                <h1 className="text-xl md:text-2xl font-semibold text-gray-800 font-poppins dark:text-white">
                    On-boarding Form Responses
                </h1>

                <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2 space-y-2 sm:space-y-0 w-full md:w-auto">

                    <button
                        onClick={() => setShowModal(true)}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        Scan QR
                    </button>
                </div>
            </div>


            <div className="space-y-2 font-poppins">
                <div className="py-4 rounded-lg">
                    
                    {/* field filter */}
                    {/* <div className="mb-2">
                        <input
                            type="text"
                            placeholder="Search by name, email, number, or status"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            className="w-full md:w-1/3 border border-gray-300 md:text-md text-xs rounded-md px-2 py-1.5 focus:outline-none focus:border focus:border-gray-400 md:placeholder:text-sm placeholder:text-xs"
                        />
                    </div> */}

                    {/* Search and filter controls */}
                    <div className="flex flex-col sm:flex-row gap-2 justify-between items-center mb-4">

                        {/* search field */}
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-full sm:w-64 dark:bg-gray-900 dark:border-gray-700 dark:text-white dark:focus:outline-none placeholder:text-xs md:placeholder:text-sm p-2 border border-gray-300 rounded-md"
                        />

                        <div className='md:w-auto w-full flex flex-col sm:flex-row items-center gap-2'>
                            <ExportToExcel data={filteredData} style={" px-4 py-2 text-sm font-medium rounded-md border border-green-400 text-green-600 hover:bg-white"} fileName="On-boarding form responses" />
                            
                            {/* filter button */}
                            <div className="flex flex-col sm:flex-row justify-between items-center gap-2 w-full sm:w-auto">
                                <div className="relative w-full ">
                                    <button 
                                        onClick={toggleFilterMenu}
                                        className="w-full p-2 border border-[#F4F7FF] dark:bg-gray-900 dark:text-white dark:border-gray-700 rounded-md flex gap-1 items-center bg-[#F4F7FF] hover:bg-gray-200"
                                        >
                                        <svg width="18" height="17" viewBox="0 0 13 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.98734 13.5608C7.85034 13.5608 7.71598 13.5252 7.59884 13.4581L5.09834 12.0415C4.817 11.8812 4.58412 11.6552 4.42215 11.3852C4.26017 11.1153 4.17457 10.8104 4.17359 10.5001V7.29493C4.17408 7.06871 4.0996 6.84803 3.96059 6.6638L0.469345 2.02988C0.387822 1.92291 0.339174 1.79674 0.328769 1.66531C0.318364 1.53387 0.346605 1.40228 0.410378 1.28504C0.474151 1.16781 0.570975 1.06949 0.690169 1.00093C0.809362 0.932381 0.94629 0.896259 1.08584 0.896552H11.8333C11.973 0.896002 12.1101 0.931967 12.2295 1.00047C12.3488 1.06896 12.4458 1.16732 12.5096 1.28465C12.5734 1.40198 12.6016 1.5337 12.5911 1.66523C12.5805 1.79677 12.5317 1.92297 12.4498 2.02988L8.95859 6.6638C8.81933 6.84794 8.74458 7.06863 8.74484 7.29493V12.844C8.74465 13.0338 8.66482 13.2158 8.52285 13.3502C8.38088 13.4845 8.18832 13.5603 7.98734 13.5608ZM1.08584 1.60843L4.57109 6.25297C4.80208 6.55645 4.92547 6.92118 4.92359 7.29493V10.4994C4.92387 10.6874 4.9756 10.8722 5.07376 11.0358C5.17192 11.1994 5.31319 11.3362 5.48384 11.433L7.98434 12.8497L7.99484 7.29422C7.99319 6.92039 8.11685 6.55566 8.34809 6.25226L11.8386 1.61834L1.08584 1.60843Z" fill="currentColor"/>
                                        </svg>
                                        <span className="ml-1">Filter</span>
                                    </button>
                                    
                                    {showFilterMenu && (
                                    <div className="absolute z-10 mt-2 md:right-0 right-auto left-0 md:left-auto bg-white dark:bg-black dark:border-gray-700 border border-gray-200 rounded-md shadow-lg p-4 w-64">
                                        <div className="flex justify-between items-center mb-3">
                                            <h3 className="font-medium dark:text-white">Filters</h3>
                                            
                                            {hasTempFilters && (
                                                <button
                                                    onClick={() => {
                                                    setActiveFilters(tempFilters);
                                                    setShowFilterMenu(false);
                                                    }}
                                                    className=" bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 text-sm"
                                                >
                                                    Apply Filters
                                                </button>
                                            )}
                                            
                                        </div>

                                        <div className="space-y-3">
                                            {filterableColumns.map((column) => (
                                                <div key={column.field} className="space-y-1">
                                                <label className="block text-sm font-medium text-gray-700 dark:text-white">
                                                    {column.label}
                                                </label>

                                                {column.field === "approval_status" ? (
                                                    <select
                                                    value={tempFilters[column.field] || ""}
                                                    // onChange={(e) => handleFilterChange(column.field, e.target.value)}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setTempFilters(prev => ({ ...prev, [column.field]: value }));
                                                    }}
                                                    className="w-full p-2 dark:bg-gray-950 dark:text-white dark:border-gray-700 text-sm border border-gray-300 rounded-md"
                                                    >
                                                    <option value="">All</option>
                                                    <option value="approved">Approved</option>
                                                    <option value="pending">Pending</option>
                                                    </select>
                                                ) : column.field === "created_at" ? (
                                                    <input
                                                    type="date"
                                                    value={
                                                        tempFilters[column.field]
                                                        ? formatToInputDate(tempFilters[column.field])
                                                        : ""
                                                    }

                                                    onChange={(e) => {
                                                        const rawValue = e.target.value;
                                                        const formattedValue = formatToDisplayDate(rawValue);
                                                        
                                                        setTempFilters(prev => ({
                                                            ...prev,
                                                            [column.field]: formattedValue
                                                        }));

                                                    }}

                                                    className="w-full dark:bg-gray-950 dark:border-gray-700 dark:text-white p-2 text-sm border border-gray-300 rounded-md"
                                                    />
                                                ) : (
                                                    <input
                                                    type="text"
                                                    value={tempFilters[column.field] || ""}
                                                    // onChange={(e) => handleFilterChange(column.field, e.target.value)}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setTempFilters(prev => ({ ...prev, [column.field]: value }));
                                                    }}
                                                    placeholder={`Filter by ${column.label.toLowerCase()}`}
                                                    className="w-full dark:bg-gray-950 dark:border-gray-700 dark:text-white  p-2 text-sm border border-gray-300 rounded-md"
                                                    />
                                                )}
                                                </div>
                                            ))}


                                        </div>
                                        
                                        {isFiltering && (
                                        <div className="mt-3 pt-3 border-t border-gray-200">
                                            <p className="text-sm text-gray-600">
                                            Showing {filteredData.length} of {formResponses.length} results
                                            </p>
                                        </div>
                                        )}
                                    </div>
                                    )}
                                </div>
                            </div>

                            {isFiltering && (
                            <div className="flex flex-wrap gap-2">
                                {Object.entries(activeFilters).map(([key, value]) => (
                                value && (
                                    <div
                                    key={key}
                                    className="flex items-center gap-2 px-3 py-1.5 border border-blue-500 bg-blue-50 dark:bg-gray-900 text-blue-600 rounded-full text-sm shadow-sm"
                                    >
                                    <span className="capitalize dark:text-white">{key.replace('_', ' ')}: {value}</span>
                                    <button
                                        onClick={() => clearFilterByKey(key)}
                                        className="w-5 h-5 flex items-center justify-center rounded-full hover:bg-blue-100 focus:outline-none"
                                        aria-label={`Clear ${key}`}
                                    >
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-4 w-4"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                    </div>
                                )
                                ))}
                                <button
                                onClick={clearFilters}
                                className="ml-2 text-sm text-red-500 hover:underline"
                                >
                                Clear All
                                </button>
                            </div>
                            )}

                        </div>

                    </div>

                    {/* data table */}
                    <div className="overflow-x-auto overflow-y-visible bg-white shadow-md rounded-lg">
                        <table className="min-w-full bg-white dark:bg-gray-900 dark:border-gray-700 border border-gray-200 text-sm text-left text-gray-700">
                            <thead className="bg-gray-100 dark:bg-gray-950">
                                <tr>
                                    <th className="py-2 px-4 text-left dark:text-white font-semibold text-xs md:text-sm text-black whitespace-nowrap">Date</th>
                                                                          {/* <th className="py-2 px-4 text-left text-xs md:text-sm text-gray-700 whitespace-nowrap">EMP ID</th> */}
                                      <th className="py-2 px-4 text-left dark:text-white font-semibold text-xs md:text-sm text-black whitespace-nowrap">Candidate Name</th>
                                      <th className="py-2 px-4 text-left dark:text-white font-semibold text-xs md:text-sm text-black whitespace-nowrap">Designation</th>
                                      {/* <th className="py-2 px-4 text-left dark:text-white font-semibold text-xs md:text-sm text-black whitespace-nowrap">Email</th>
                                      <th className="py-2 px-4 text-left dark:text-white font-semibold text-xs md:text-sm text-black whitespace-nowrap">Contact Number</th> */}
                                    <th className="py-2 px-4 text-left dark:text-white font-semibold text-xs md:text-sm text-black whitespace-nowrap">Status</th>
                                    <th className="py-2 px-4 text-left dark:text-white font-semibold text-xs md:text-sm text-black whitespace-nowrap">Approved By</th>
                                    <th className="py-2 px-4 text-left dark:text-white font-semibold text-xs md:text-sm text-black whitespace-nowrap">Comment</th>
                                    <th className="py-2 px-4 text-center dark:text-white font-semibold text-xs md:text-sm text-black whitespace-nowrap">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                            {loading ? (
                                <tr className="border-b dark:border-gray-700 dark:text-white dark:hover:bg-black hover:bg-gray-100">
                                    <td colSpan="6" className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                        <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                                        {/* <p className="text-sm text-center text-gray-500">Loading reports...</p> */}
                                    </td>
                                </tr>
                            ) : error ? (
                                <tr className="border-b dark:border-gray-700 dark:text-white dark:hover:bg-black hover:bg-gray-100">
                                    <td colSpan={6} className='py-2 px-4 text-xs md:text-sm whitespace-nowrap'>
                                        {error}
                                    </td>
                                </tr>
                            ) : filteredData.length === 0 ? (
                                <tr className="border-b dark:border-gray-700 dark:text-white dark:hover:bg-black hover:bg-gray-100">
                                    <td colSpan={6} className='py-2 px-4 text-center text-xs md:text-sm whitespace-nowrap'>
                                        No responses available.
                                    </td>
                                </tr>
                            ) : (
                                filteredData
                                    .map((submission, index) => (
                                    <tr key={index} className="border-b dark:border-gray-700 dark:text-white dark:hover:bg-black hover:bg-gray-100">
                                        <td className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                        {submission.created_at
                                            ? (() => {
                                                const d = new Date(submission.created_at);
                                                const day = String(d.getDate()).padStart(2, '0');
                                                const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                                                const year = d.getFullYear();
                                                return `${day}-${month}-${year}`;
                                            })()
                                            : '-'}
                                        </td>
                                        {/* <td className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                            {submission.employee_id || '-'}
                                        </td> */}
                                        <td className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                            <button className="text-blue-500 hover:text-blue-700 hover:underline hover:underline-offset-4" onClick={() => {
                                                setSelectedSubmission({
                                                    ...submission
                                                });
                                                setOriginalData(submission)
                                                setIsDrawerOpen(true);
                                            }}>{submission.full_name || '-'}
                                            </button>
                                        </td>
                                        <td className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                            {submission.designation || '-'}
                                        </td>
                                        {/* <td className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                            {submission.email || '-'}
                                        </td>
                                        <td className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                            {submission.contact_number || '-'}
                                        </td> */}
                                        <td className="flex items-center gap-1 py-2 px-4 text-xs md:text-sm whitespace-nowrap capitalize">
                                            <span
                                                className={`flex items-center gap-1 px-3 py-1 rounded-full ${
                                                    submission.approval_status === 'approved'
                                                        ? 'bg-green-500 text-white'
                                                        : submission.approval_status === 'rejected'
                                                        ? 'bg-red-500 text-white'
                                                        : 'bg-yellow-200 text-black'
                                                }`}>
                                                {submission.approval_status}
                                                
                                            </span>
                                        </td>
                                        <td className="py-2 px-4 text-xs md:text-sm whitespace-nowrap">
                                            {submission.approved_by || '-'}
                                        </td>
                                        <td className="py-2 px-4 text-center text-xs md:text-sm whitespace-nowrap">
                                            {submission.hr_comments ? (
                                            <button
                                                className="text-blue-500 hover:text-blue-700 hover:underline hover:underline-offset-4"
                                                onClick={() => {
                                                setOpenCommentId(submission.id);
                                                setCommentSubmission(submission);
                                                }}
                                                title="View Comment">
                                                <svg className='w-5 h-5 text-black dark:text-white' data-slot="icon" aria-hidden="true" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>
                                            </button>
                                            ) : "-"}
                                        </td>
                                        <td className="py-2 px-4 text-xs text-center md:text-sm whitespace-nowrap">
                                            <div className="relative dropdown-container">
                                                <button
                                                    onClick={(e) => handleDropdownToggle(submission.id, e)}
                                                    className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
                                                >
                                                    <MoreVertical className="w-4 h-4 text-gray-600 dark:text-gray-400" />
                                                </button>
                                                
                                                {openDropdownId === submission.id && (
                                                    <div className={`absolute right-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-[9999] min-w-[200px] ${
                                                        dropdownPosition === 'top' 
                                                            ? 'bottom-full mb-1' 
                                                            : 'top-full mt-1'
                                                    }`} style={{
                                                        maxHeight: '300px',
                                                        overflowY: 'auto'
                                                    }}>
                                                        <div className="py-1 flex flex-col space-y-0">

                                                            {/* View Details */}
                                                            <button
                                                                onClick={() => {
                                                                    setSelectedSubmission({
                                                                        ...submission
                                                                    });
                                                                    setOriginalData(submission)
                                                                    setIsDrawerOpen(true);
                                                                    setOpenDropdownId(null);
                                                                }}
                                                                className="w-full text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors block"
                                                            >
                                                                View Details
                                                            </button>

                                                            {/* Approval Actions for Pending */}
                                                            {submission.approval_status === 'pending' && (
                                                                <>
                                                                    <button
                                                                        onClick={() => {
                                                                            openApprovalModal(submission, 'approved');
                                                                            setOpenDropdownId(null);
                                                                        }}
                                                                        className="w-full text-left px-3 py-2 text-sm text-green-600 hover:bg-green-50 dark:hover:bg-green-900/20 transition-colors block"
                                                                    >
                                                                        Approve
                                                                    </button>
                                                                    <button
                                                                        onClick={() => {
                                                                            openApprovalModal(submission, 'rejected');
                                                                            setOpenDropdownId(null);
                                                                        }}
                                                                        className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors block"
                                                                    >
                                                                        Reject
                                                                    </button>
                                                                </>
                                                            )}

                                                            {/* View Approver for Approved */}
                                                            {submission.approval_status === 'approved' && (
                                                                <button
                                                                    onClick={() => {
                                                                        setApproverDetails(submission);
                                                                        setIsApproverModalOpen(true);
                                                                        setOpenDropdownId(null);
                                                                    }}
                                                                    className="w-full text-left px-3 py-2 text-sm text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-900/20 transition-colors block"
                                                                >
                                                                    View Approver
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </table>
                    </div>
                    {/* data table */}

                    {!isFiltering && filteredData?.length > 0 && (
                        <ReactPaginate
                        breakLabel="..."
                        nextLabel="Next >"
                        onPageChange={(event) => handlePageChange(event.selected + 1)}
                        forcePage={currentPage - 1}
                        pageRangeDisplayed={5}
                        pageCount={pagination.totalPages}
                        previousLabel="< Prev"
                        previousClassName='dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-800'
                        nextClassName="dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-800"
                        renderOnZeroPageCount={null}
                        containerClassName="flex items-center justify-center mt-4 font-poppins"
                        pageClassName="mx-1 px-3 py-1 border rounded dark:text-white font-poppins"
                        activeClassName="bg-blue-500 text-white dark:bg-black dark:text-white dark:border-gray-700 font-poppins"
                        />
                    )}

                </div>
            </div>
            
            {/* drawer */}
            <Drawer 
                isOpen={isDrawerOpen} 
                onClose={() => {
                    setIsDrawerOpen(false);
                    setIsEditMode(false); 
                }} 
                ChilDiv="" 
                ChildParent="" 
                height_width="w-full md:h-full" 
                border_radius="md:rounded-lg" 
                title="Submission Details" 
                showClose={false}>
                {selectedSubmission ? (

                <div className="rounded-lg p-2 font-poppins">
                    {/* Tabs Navigation */}
                    <div className="sticky top-0 z-20 bg-white ">
                        <button
                            onClick={() => {
                                setIsDrawerOpen(false);
                                setIsEditMode(false); 
                            }}
                            className="float-right p-1 text-red-500 dark:hover:text-gray-400 hover:text-red-700 text-xl"
                            >
                            ✖
                        </button>

                        {/* tabs */}
                        <div className="flex justify-between items-center  p-4">
                             {tabs.map(tab => (
                                 <button
                                     key={tab.id}
                                     onClick={() => setActiveTab(tab.id)}
                                     className={`flex items-center gap-2 px-4 py-3 font-medium text-sm whitespace-nowrap transition-colors
                                         ${activeTab === tab.id 
                                         ? 'border-b-2 dark:text-white border-blue-600 text-blue-600' 
                                         : 'text-gray-500 dark:text-gray-400 hover:text-gray-700'}`}
                                     aria-current={activeTab === tab.id ? 'page' : undefined}>
                                     {tab.icon}
                                     {tab.label}
                                 </button>
                             ))}
                         </div>
                     </div>

                    {/* Tab Content */}
                    <div className="p-4">
                        {/* Personal Information Tab */}
                        {activeTab === 'personal' && (
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-white">Personal Information</h3>
                            
                            {/* personal information */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                {[
                                { key: 'full_name', label: 'Name', required: true },
                                { key: 'email', label: 'Email', required: true },
                                { key: 'contact_number', label: 'Contact Number', required: true },
                                { key: 'date_of_birth', label: 'Date of Birth', type: 'date', required: true },
                                { key: 'date_of_joining', label: 'Date of Joining', type: 'date', required: true },
                                { key: 'highest_qualification', label: 'Highest Qualification', required: true },
                                { key: 'year_of_passing', label: 'Year of Passing', required: true },
                                { key: 'blood_group', label: 'Blood Group', required: true },
                                ].map(({ key, label, type, required }) => (
                                <div className="flex flex-col gap-1" key={key}>
                                    <label className="text-gray-600 dark:text-white text-sm font-medium">
                                        {label}
                                        {required && <span className="text-red-500 ml-1">*</span>}
                                    </label> 

                                    {isEditMode ? (
                                    <input
                                        type={type || 'text'}
                                        className={`border rounded dark:text-white dark:focus:outline-none dark:border-gray-700 dark:bg-black px-3 py-2 focus:outline-none focus:ring-2 ${
                                            fieldErrors[key]
                                            ? 'border-red-500 focus:ring-red-400'
                                            : 'focus:ring-blue-500'
                                        }`}
                                        value={
                                            type === 'date'
                                            ? formatDateForInput(selectedSubmission[key])
                                            : selectedSubmission[key] || ''
                                        }
                                        onChange={(e) => {
                                            let value = e.target.value;

                                            // Full name: allow only letters and spaces
                                            if (key === 'full_name') {
                                            if (!/^[a-zA-Z\s]*$/.test(value)) return;
                                            }

                                            // Contact number: allow only digits
                                            if (key === 'contact_number') {
                                            if (!/^\d*$/.test(value)) return;
                                            }

                                            setSelectedSubmission((prev) => ({ ...prev, [key]: value }));
                                        }}
                                        onBlur={(e) => {
                                            let value = e.target.value.trim();
                                            let error = '';

                                            if (!value) {
                                            error = `${label} is required`;
                                            } else {
                                            if (key === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                                                error = 'Invalid email format';
                                            } else if (key === 'contact_number' && !/^\d{10}$/.test(value)) {
                                                error = 'Contact number must be 10 digits';
                                            } else if (key === 'blood_group' && !/^(A|B|AB|O)[+-]$/.test(value.toUpperCase())) {
                                                error = 'Invalid blood group (e.g., A+, O-, AB-)';
                                            } else if (key === 'full_name' && !/^[a-zA-Z\s]+$/.test(value)) {
                                                error = 'Name can only contain letters and spaces';
                                            }
                                            }

                                            if (key === 'blood_group') {
                                                const validBloodGroups = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
                                                value = value.toUpperCase(); // Normalize to uppercase
                                                if (!validBloodGroups.includes(value)) {
                                                    error = 'Invalid blood group (e.g., A+, O-, AB+)';
                                                }   
                                            }

                                            setFieldErrors((prev) => ({ ...prev, [key]: error }));
                                            setSelectedSubmission((prev) => ({ ...prev, [key]: value }));
                                        }}
                                    />
                                    ) : (
                                    <div className="px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200">
                                        {type === 'date' 
                                            ? (selectedSubmission[key] ? new Date(selectedSubmission[key]).toLocaleDateString() : '-')
                                            : selectedSubmission[key] || '-'
                                        }
                                    </div>
                                    )}

                                    {fieldErrors[key] && (
                                        <p className="text-red-500 text-sm mt-1">{fieldErrors[key]}</p>
                                    )}
                                </div>
                                ))}

                            </div>

                            {/* current and perm. address */}
                            <div className="grid grid-cols-1 gap-6">

                                <div className="grid grid-cols-1 gap-6">
                                    {/* Checkbox for same address */}
                                    {isEditMode && (
                                        <div className="flex items-center gap-3 p-4 border border-dashed border-blue-300 dark:border-blue-600 rounded-lg bg-blue-50 dark:bg-blue-900/10">
                                        <input
                                            type="checkbox"
                                            id="sameAddress"
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                            checked={selectedSubmission.current_address === selectedSubmission.permanent_address && !!selectedSubmission.permanent_address}
                                            onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            if (isChecked) {
                                                setSelectedSubmission((prev) => ({
                                                ...prev,
                                                permanent_address: prev.current_address || '',
                                                }));
                                                setFieldErrors((prev) => ({
                                                ...prev,
                                                current_address: '',
                                                }));
                                            }
                                            }}
                                        />
                                        <label htmlFor="sameAddress" className="text-sm text-blue-700 dark:text-blue-300 font-medium flex items-center gap-2">
                                            <MapPin size={14} />
                                            Keep Permanent Address Same as Current Address
                                        </label>
                                        </div>
                                    )}

                                    {[
                                        { key: 'current_address', label: 'Current Address' },
                                        { key: 'permanent_address', label: 'Permanent Address' },
                                    ].map(({ key, label }) => (
                                        <div className="flex flex-col gap-1" key={key}>
                                        <label className="text-gray-600 dark:text-white text-sm font-medium flex items-center gap-2">
                                            {/* {getFieldIcon(key)} */}
                                            {label}
                                        </label>
                                        
                                        {isEditMode ? (
                                            <textarea
                                            className={`border rounded-lg dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-gray-800 px-3 py-3 min-h-20 focus:outline-none focus:ring-2 transition-all duration-200 resize-none ${
                                                fieldErrors[key]
                                                ? 'border-red-500 focus:ring-red-400 bg-red-50 dark:bg-red-900/10'
                                                : 'focus:ring-blue-500 hover:border-gray-400 dark:hover:border-gray-600'
                                            }`}
                                            value={selectedSubmission[key] || ''}
                                            onChange={(e) =>
                                                setSelectedSubmission((prev) => ({
                                                ...prev,
                                                [key]: e.target.value,
                                                }))
                                            }
                                            onBlur={(e) => {
                                                const value = e.target.value.trim();
                                                let error = '';

                                                if (!value) {
                                                error = `${label} is required`;
                                                }

                                                setFieldErrors((prev) => ({ ...prev, [key]: error }));
                                                setSelectedSubmission((prev) => ({ ...prev, [key]: value }));
                                            }}
                                            placeholder={`Enter your ${label.toLowerCase()}...`}
                                            />
                                        ) : (
                                            <div className="px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200 min-h-20 whitespace-pre-wrap">
                                            {selectedSubmission[key] || '-'}
                                            </div>
                                        )}
                                        
                                        {fieldErrors[key] && (
                                            <div className="flex items-center gap-1 text-red-500 text-sm mt-1">
                                            <X size={12} />
                                            {fieldErrors[key]}
                                            </div>
                                        )}
                                        </div>
                                    ))}
                                
                                </div>
                            </div>

                            {/* emerg. contact 1, emerg. name 1, emerg. relation 1, emerg. contact 2, emerg. name 2, emerg. relation 2*/}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                
                                <div>
                                    <h4 className="text-md font-medium mb-3 text-gray-700 dark:text-white">Emergency Contact 1</h4>
                                    <div className="space-y-4">

                                        {/* Emergency Contact 1 */}
                                        <div className="flex flex-col gap-1">
                                            <label className="text-gray-600 dark:text-white text-sm font-medium">
                                                Contact Number
                                                <span className="text-red-500 ml-1">*</span>    
                                            </label>
                                            
                                            {isEditMode ? (
                                                <input
                                                    type="text"
                                                    className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                                    fieldErrors.emergency_contact_1
                                                        ? 'border-red-500 focus:ring-red-400'
                                                        : 'focus:ring-blue-500'
                                                    }`}
                                                    value={selectedSubmission.emergency_contact_1 || ''}
                                                    onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only digits (basic filter, optional)
                                                    if (/^\d*$/.test(value)) {
                                                        setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_contact_1: value,
                                                        }));
                                                    }
                                                    }}
                                                    onBlur={(e) => {
                                                    const value = e.target.value.trim();
                                                    let error = '';

                                                    if (!value) {
                                                        error = 'Contact Number is required';
                                                    } else if (!/^\d{10}$/.test(value)) {
                                                        error = 'Contact Number must be exactly 10 digits';
                                                    }

                                                    setFieldErrors((prev) => ({
                                                        ...prev,
                                                        emergency_contact_1: error,
                                                    }));

                                                    setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_contact_1: value,
                                                    }));
                                                    }}
                                                />
                                            ) : (
                                            <div className="px-3 py-3 bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800 rounded-lg text-gray-800 dark:text-gray-200 flex items-center gap-2">
                                                <Phone size={16} className="text-red-500" />
                                                <span className="font-mono">
                                                {selectedSubmission.emergency_contact_1 
                                                    ? `+91 ${selectedSubmission.emergency_contact_1.slice(0, 5)} ${selectedSubmission.emergency_contact_1.slice(5)}`
                                                    : '-'
                                                }
                                                </span>
                                                {selectedSubmission.emergency_contact_1 && (
                                                <span className="ml-auto px-2 py-1 bg-red-200 dark:bg-red-800/50 text-red-700 dark:text-red-300 text-xs rounded font-medium">
                                                    Emergency
                                                </span>
                                                )}
                                            </div>
                                            )}

                                            {fieldErrors.emergency_contact_1 && (
                                                <p className="text-red-500 text-sm">{fieldErrors.emergency_contact_1}</p>
                                            )}
                                        </div>

                                        {/* emergency name 1 */}
                                        <div className="flex flex-col gap-1">
                                            <label className="text-gray-600 text-sm font-medium dark:text-white">
                                                Full Name
                                                <span className="text-red-500 ml-1">*</span>
                                            </label>
                                            
                                            {isEditMode ? (
                                                <input
                                                    type="text"
                                                    className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                                    fieldErrors.emergency_name_1
                                                        ? 'border-red-500 focus:ring-red-400'
                                                        : 'focus:ring-blue-500'
                                                    }`}
                                                    value={selectedSubmission.emergency_name_1 || ''}
                                                    onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow alphabets, spaces, and hyphens only
                                                    if (/^[a-zA-Z\s-]*$/.test(value)) {
                                                        setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_name_1: value,
                                                        }));
                                                    }
                                                    }}
                                                    onBlur={(e) => {
                                                    const value = e.target.value.trim();
                                                    let error = '';

                                                    if (!value) {
                                                        error = 'Full Name is required';
                                                    } else if (!/^[a-zA-Z\s-]+$/.test(value)) {
                                                        error = 'Only alphabets, spaces, and hyphens are allowed';
                                                    }

                                                    setFieldErrors((prev) => ({
                                                        ...prev,
                                                        emergency_name_1: error,
                                                    }));

                                                    setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_name_1: value,
                                                    }));
                                                    }}
                                                />
                                            ) : (
                                            <div className="px-3 py-3 bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800 rounded-lg text-gray-800 dark:text-gray-200 flex items-center gap-2">
                                                <User size={16} className="text-red-500" />
                                                <span className="font-medium">
                                                {selectedSubmission.emergency_name_1 || '-'}
                                                </span>
                                                {selectedSubmission.emergency_name_1 && (
                                                <span className="ml-auto px-2 py-1 bg-red-200 dark:bg-red-800/50 text-red-700 dark:text-red-300 text-xs rounded font-medium">
                                                    Full Name
                                                </span>
                                                )}
                                            </div>
                                            )}

                                            {fieldErrors.emergency_name_1 && (
                                                <p className="text-red-500 text-sm">{fieldErrors.emergency_name_1}</p>
                                            )}
                                        </div>

                                        {/* emergency relation 1 */}
                                        <div className="flex flex-col gap-1">
                                            <label className="text-gray-600 text-sm font-medium dark:text-white">
                                                Relation
                                                <span className="text-red-500 ml-1">*</span>
                                            </label>

                                            {isEditMode ? (
                                                <input
                                                    type="text"
                                                    className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                                    fieldErrors.emergency_relation_1
                                                        ? 'border-red-500 focus:ring-red-400'
                                                        : 'focus:ring-blue-500'
                                                    }`}
                                                    value={selectedSubmission.emergency_relation_1 || ''}
                                                    onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow alphabets and spaces only
                                                    if (/^[a-zA-Z\s]*$/.test(value)) {
                                                        setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_relation_1: value,
                                                        }));
                                                    }
                                                    }}
                                                    onBlur={(e) => {
                                                    const value = e.target.value.trim();
                                                    let error = '';

                                                    if (!value) {
                                                        error = 'Relation is required';
                                                    } else if (!/^[a-zA-Z\s]+$/.test(value)) {
                                                        error = 'Only alphabets and spaces are allowed';
                                                    }

                                                    setFieldErrors((prev) => ({
                                                        ...prev,
                                                        emergency_relation_1: error,
                                                    }));

                                                    setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_relation_1: value,
                                                    }));
                                                    }}
                                                />
                                            ) : (
                                            <div className="px-3 py-3 bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800 rounded-lg text-gray-800 dark:text-gray-200 flex items-center gap-2">
                                                <User size={16} className="text-red-500" />
                                                <span className="font-medium">
                                                {selectedSubmission.emergency_relation_1 || '-'}
                                                </span>
                                                {selectedSubmission.emergency_relation_1 && (
                                                <span className="ml-auto px-2 py-1 bg-red-200 dark:bg-red-800/50 text-red-700 dark:text-red-300 text-xs rounded font-medium">
                                                    Relation
                                                </span>
                                                )}
                                            </div>
                                            )}
                                            
                                            {fieldErrors.emergency_relation_1 && (
                                                <p className="text-red-500 text-sm">{fieldErrors.emergency_relation_1}</p>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                <div>
                                    <h4 className="text-md font-medium mb-3 text-gray-700 dark:text-white">Emergency Contact 2</h4>
                                    <div className="space-y-4">

                                        {/* emergency contact 2 */}
                                        <div className="flex flex-col gap-1">
                                            <label className="text-gray-600 dark:text-white text-sm font-medium">
                                                Contact Number
                                                <span className="text-red-500 ml-1">*</span>
                                            </label>

                                            {isEditMode ? (
                                                <input
                                                    type="text"
                                                    className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                                    fieldErrors.emergency_contact_2
                                                        ? 'border-red-500 focus:ring-red-400'
                                                        : 'focus:ring-blue-500'
                                                    }`}
                                                    value={selectedSubmission.emergency_contact_2 || ''}
                                                    onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only digits (basic filter, optional)
                                                    if (/^\d*$/.test(value)) {
                                                        setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_contact_2: value,
                                                        }));
                                                    }
                                                    }}
                                                    onBlur={(e) => {
                                                    const value = e.target.value.trim();
                                                    let error = '';

                                                    if (!value) {
                                                        error = 'Contact Number is required';
                                                    } else if (!/^\d{10}$/.test(value)) {
                                                        error = 'Contact Number must be exactly 10 digits';
                                                    }

                                                    setFieldErrors((prev) => ({
                                                        ...prev,
                                                        emergency_contact_2: error,
                                                    }));

                                                    setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_contact_2: value,
                                                    }));
                                                    }}
                                                />
                                            ) : (
                                            <div className="px-3 py-3 bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800 rounded-lg text-gray-800 dark:text-gray-200 flex items-center gap-2">
                                                <Phone size={16} className="text-red-500" />
                                                <span className="font-mono">
                                                {selectedSubmission.emergency_contact_2 
                                                    ? `+91 ${selectedSubmission.emergency_contact_2.slice(0, 5)} ${selectedSubmission.emergency_contact_2.slice(5)}`
                                                    : '-'
                                                }
                                                </span>
                                                {selectedSubmission.emergency_contact_2 && (
                                                <span className="ml-auto px-2 py-1 bg-red-200 dark:bg-red-800/50 text-red-700 dark:text-red-300 text-xs rounded font-medium">
                                                    Emergency
                                                </span>
                                                )}
                                            </div>        
                                            )}

                                            {fieldErrors.emergency_contact_2 && (
                                                <p className="text-red-500 text-sm">{fieldErrors.emergency_contact_2}</p>
                                            )}
                                        </div>

                                        {/* emergency name 2 */}
                                        <div className="flex flex-col gap-1">
                                            <label className="text-gray-600 text-sm font-medium dark:text-white">
                                                Full Name
                                                <span className="text-red-500 ml-1">*</span>
                                            </label>
                                            {isEditMode ? (
                                                <input
                                                    type="text"
                                                    className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                                    fieldErrors.emergency_name_2
                                                        ? 'border-red-500 focus:ring-red-400'
                                                        : 'focus:ring-blue-500'
                                                    }`}
                                                    value={selectedSubmission.emergency_name_2 || ''}
                                                    onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow alphabets, spaces, and hyphens only
                                                    if (/^[a-zA-Z\s-]*$/.test(value)) {
                                                        setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_name_2: value,
                                                        }));
                                                    }
                                                    }}
                                                    onBlur={(e) => {
                                                    const value = e.target.value.trim();
                                                    let error = '';

                                                    if (!value) {
                                                        error = 'Full Name is required';
                                                    } else if (!/^[a-zA-Z\s-]+$/.test(value)) {
                                                        error = 'Only alphabets, spaces, and hyphens are allowed';
                                                    }

                                                    setFieldErrors((prev) => ({
                                                        ...prev,
                                                        emergency_name_2: error,
                                                    }));

                                                    setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_name_2: value,
                                                    }));
                                                    }}
                                                />
                                            ) : (
                                            <div className="px-3 py-3 bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800 rounded-lg text-gray-800 dark:text-gray-200 flex items-center gap-2">
                                                <User size={16} className="text-red-500" />
                                                <span className="font-medium">
                                                {selectedSubmission.emergency_name_2 || '-'}
                                                </span>
                                                {selectedSubmission.emergency_name_2 && (
                                                <span className="ml-auto px-2 py-1 bg-red-200 dark:bg-red-800/50 text-red-700 dark:text-red-300 text-xs rounded font-medium">
                                                    Full Name
                                                </span>
                                                )}
                                            </div>
                                            )}
                                            {fieldErrors.emergency_name_2 && (
                                                <p className="text-red-500 text-sm">{fieldErrors.emergency_name_2}</p>
                                            )}
                                        </div>

                                        {/* emergency relation 2 */}
                                        <div className="flex flex-col gap-1">
                                            <label className="text-gray-600 text-sm font-medium dark:text-white">
                                                Relation
                                                <span className="text-red-500 ml-1">*</span>
                                            </label>

                                            {isEditMode ? (
                                                <input
                                                    type="text"
                                                    className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                                    fieldErrors.emergency_relation_2
                                                        ? 'border-red-500 focus:ring-red-400'
                                                        : 'focus:ring-blue-500'
                                                    }`}
                                                    value={selectedSubmission.emergency_relation_2 || ''}
                                                    onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow alphabets and spaces only
                                                    if (/^[a-zA-Z\s]*$/.test(value)) {
                                                        setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_relation_2: value,
                                                        }));
                                                    }
                                                    }}
                                                    onBlur={(e) => {
                                                    const value = e.target.value.trim();
                                                    let error = '';

                                                    if (!value) {
                                                        error = 'Relation is required';
                                                    } else if (!/^[a-zA-Z\s]+$/.test(value)) {
                                                        error = 'Only alphabets and spaces are allowed';
                                                    }

                                                    setFieldErrors((prev) => ({
                                                        ...prev,
                                                        emergency_relation_2: error,
                                                    }));

                                                    setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        emergency_relation_2: value,
                                                    }));
                                                    }}
                                                />
                                            ) : (
                                            <div className="px-3 py-3 bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800 rounded-lg text-gray-800 dark:text-gray-200 flex items-center gap-2">
                                                <User size={16} className="text-red-500" />
                                                <span className="font-medium">
                                                {selectedSubmission.emergency_relation_2 || '-'}
                                                </span>
                                                {selectedSubmission.emergency_relation_2 && (
                                                <span className="ml-auto px-2 py-1 bg-red-200 dark:bg-red-800/50 text-red-700 dark:text-red-300 text-xs rounded font-medium">
                                                    Relation
                                                </span>
                                                )}
                                            </div>
                                            )}

                                            {fieldErrors.emergency_relation_2 && (
                                                <p className="text-red-500 text-sm">{fieldErrors.emergency_relation_2}</p>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                        )}

                        {/* Employment Tab */}
                        {activeTab === 'employment' && (
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-white">Employment Details</h3>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                {[
                                { key: 'designation', label: 'Designation', required: true },
                                { key: 'employee_type', label: 'Employment Type', readOnly: true },
                                ].map(({ key, label, readOnly, required }) => (
                                <div className="flex flex-col gap-1" key={key}>
                                    <label className="text-gray-600 text-sm font-medium dark:text-white">
                                        {label}
                                        {required && <span className="text-red-500 ml-1">*</span>}
                                    </label>

                                    {isEditMode ? (
                                        <input
                                        type="text"
                                        required
                                        className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 ${
                                            readOnly
                                            ? 'bg-gray-100 cursor-not-allowed'
                                            : fieldErrors[key]
                                            ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                            : 'focus:outline-none focus:ring-2 focus:ring-blue-500'
                                        }`}
                                        value={selectedSubmission[key] || ''}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (key === 'designation') {
                                            // Allow only alphabets, spaces, and hyphens
                                            const validText = /^[a-zA-Z\s-]*$/.test(value);
                                            if (!validText) return;
                                            }

                                            setSelectedSubmission((prev) => ({
                                            ...prev,
                                            [key]: value,
                                            }));
                                        }}
                                        onBlur={(e) => {
                                            const value = e.target.value.trim();
                                            let error = '';

                                            if (key === 'designation') {
                                            if (!value) {
                                                error = 'Designation is required';
                                            } else if (!/^[a-zA-Z\s-]+$/.test(value)) {
                                                error = 'Designation can only contain letters, spaces, and hyphens';
                                            }
                                            }

                                            setFieldErrors((prev) => ({
                                            ...prev,
                                            [key]: error,
                                            }));

                                            if (!readOnly) {
                                            setSelectedSubmission((prev) => ({
                                                ...prev,
                                                [key]: value,
                                            }));
                                            }
                                        }}
                                        readOnly={readOnly}
                                        disabled={readOnly}
                                        />
                                    ) : (
                                    <div className="px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200">
                                        {selectedSubmission[key] || '-'}
                                    </div>
                                    )}

                                    {fieldErrors[key] && (
                                    <p className="text-red-500 text-sm mt-1">{fieldErrors[key]}</p>
                                    )}
                                </div>
                                ))}

                            </div>

                            {selectedSubmission.approval_status === 'approved' && (
                            <div className="bg-white dark:bg-gray-800 dark:border-gray-700 p-6 rounded-lg shadow-sm border border-gray-200">
                                <h4 className="font-medium mb-4 text-gray-700 dark:text-white">Position Details</h4>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {[
                                    { key: 'employee_id_by_hr', label: 'Employee ID' },
                                    { key: 'employee_is_bfl', label: 'Is BFL Employee' },
                                    { key: 'employee_official_email', label: 'Official Email' },
                                    { key: 'employee_department', label: 'Employee Department' },
                                    { key: 'employee_process', label: 'Employee Process' },
                                    { key: 'employee_probation_period', label: 'Probation Period' },
                                    { key: 'employee_notice_period', label: 'Notice Period' },
                                    { key: 'employee_reporting_to', label: 'Reporting To' },
                                ].map(({ key, label }) => (
                                    <div key={key} className="flex flex-col gap-1">
                                    <label className="text-gray-600 text-sm font-medium dark:text-white">{label}</label>
                                    {isEditMode ? (
                                        key === 'employee_is_bfl' ? (
                                            <select
                                                className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                                    fieldErrors[key]
                                                        ? 'border-red-500 focus:ring-red-400'
                                                        : 'focus:ring-blue-500'
                                                }`}
                                                value={selectedSubmission[key] || ''}
                                                onChange={e => {
                                                    let value = e.target.value;
                                                    setSelectedSubmission(prev => ({ ...prev, [key]: value }));
                                                }}
                                                onBlur={e => {
                                                    let value = e.target.value.trim();
                                                    let error = '';
                                                    if (!value) {
                                                        error = `${label} is required`;
                                                    }
                                                    setFieldErrors(prev => ({ ...prev, [key]: error }));
                                                    setSelectedSubmission(prev => ({ ...prev, [key]: value }));
                                                }}
                                            >
                                                <option value="">Select...</option>
                                                <option value="yes">Yes</option>
                                                <option value="no">No</option>
                                            </select>
                                        ) : (
                                            <input
                                                type="text"
                                                className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                                    fieldErrors[key]
                                                        ? 'border-red-500 focus:ring-red-400'
                                                        : 'focus:ring-blue-500'
                                                }`}
                                                value={selectedSubmission[key] || ''}
                                                onChange={e => {
                                                    let value = e.target.value;
                                                    setSelectedSubmission(prev => ({ ...prev, [key]: value }));
                                                }}
                                                onBlur={e => {
                                                    let value = e.target.value.trim();
                                                    let error = '';
                                                    if (!value) {
                                                        error = `${label} is required`;
                                                    }
                                                    setFieldErrors(prev => ({ ...prev, [key]: error }));
                                                    setSelectedSubmission(prev => ({ ...prev, [key]: value }));
                                                }}
                                            />
                                        )
                                      ) : (
                                        <div className="px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200">
                                          {key === 'employee_is_bfl' && selectedSubmission[key] ? 
                                            (selectedSubmission[key] === 'yes' ? 'Yes' : 'No') : 
                                            selectedSubmission[key] || '-'}
                                        </div>
                                      )}
                                      {fieldErrors[key] && (
                                        <span className="text-sm text-red-500">{fieldErrors[key]}</span>
                                      )}
                                    </div>
                                ))}
                                </div>
                            </div>
                            )}

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {[
                                { key: 'uan_number', label: 'UAN Number', required: true },
                                { key: 'esic_number', label: 'ESIC Number', required: true },
                                { key: 'pan_number', label: 'PAN Number', required: true },
                                { key: 'aadhar_number', label: 'Aadhar Number', required: true },
                            ].map(({ key, label, required }) => (
                                <div className="flex flex-col gap-1" key={key}>
                                <label className="text-gray-600 text-sm font-medium dark:text-white">
                                    {label}
                                    {required && <span className="text-red-500 ml-1">*</span>}
                                </label>

                                {isEditMode ? (
                                    <input
                                        type="text"
                                        className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                        fieldErrors[key]
                                            ? 'border-red-500 focus:ring-red-400'
                                            : 'focus:ring-blue-500'
                                        }`}
                                        value={selectedSubmission[key] || ''}
                                        onChange={(e) => {
                                        let value = e.target.value;
                                        // Always allow typing for better UX
                                        setSelectedSubmission((prev) => ({ ...prev, [key]: value }));
                                        }}
                                        onBlur={(e) => {
                                        let value = e.target.value.trim();
                                        let error = '';
                                        const isNA = value.toLowerCase() === 'na';

                                        if (!value) {
                                            error = `${label} is required`;
                                        } else {
                                            if (key === 'uan_number' && !isNA && !/^\d{12}$/.test(value)) {
                                            error = 'UAN must be 12 digits or "NA"';
                                            } else if (
                                            key === 'esic_number' &&
                                            !isNA &&
                                            !/^\d{10}$/.test(value)
                                            ) {
                                            error = 'ESIC must be 10 digits or "NA"';
                                            } else if (
                                            key === 'aadhar_number' &&
                                            !/^\d{12}$/.test(value)
                                            ) {
                                            error = 'Aadhar must be exactly 12 digits';
                                            } else if (
                                            key === 'pan_number' &&
                                            !isNA &&
                                            !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value.toUpperCase())
                                            ) {
                                            error = 'PAN format is invalid (e.g., ABCDE1234F) or "NA"';
                                            }
                                        }

                                        // Normalize NA to uppercase
                                        if (isNA) value = 'NA';

                                        setFieldErrors((prev) => ({ ...prev, [key]: error }));
                                        setSelectedSubmission((prev) => ({ ...prev, [key]: value }));
                                        }}
                                    />
                                ) : (
                                <div className="px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200">
                                    {selectedSubmission[key] || '-'}
                                </div>        
                                )}

                                {fieldErrors[key] && (
                                    <span className="text-sm text-red-500">{fieldErrors[key]}</span>
                                )}
                                </div>
                            ))}
                            </div>
                        </div>
                        )}

                        {/* Documents Tab */}
                        {activeTab === 'documents' && (
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-80 dark:text-white">Required Documents</h3>
                            <div className="bg-white dark:bg-black dark:border-gray-700 p-6 rounded-lg shadow-sm border border-gray-200">
                            {selectedSubmission?.documents && typeof selectedSubmission?.documents === 'object' && (
                                <div className="grid grid-cols-1 gap-6">
                                {Object.entries(selectedSubmission?.documents).map(([docKey, docValue]) => (
                                <div key={docKey} className="flex flex-col gap-2 p-4 dark:border-gray-700 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors">
                                    <label className="text-gray-700 capitalize font-medium dark:text-white">
                                        {docKey.replace(/_/g, ' ')}:
                                    </label>
                                    <div className="flex items-center gap-4">
                                        {docValue?.preview_url ? (
                                            // <a
                                            // href={docValue.preview_url}
                                            // target="_blank"
                                            // rel="noopener noreferrer"
                                            // className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                            // >
                                            // <FileText className="w-4 h-4" />
                                            // View current file
                                            // </a>
                                            <button
                                                onClick={() => {
                                                setPreviewUrl(docValue.preview_url);
                                                setDownloadUrl(docValue);
                                                setIsPreviewOpen(true);
                                                }}
                                                className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                            >
                                                <FileText className="w-4 h-4" />
                                                View current file
                                            </button>
                                        ) : (
                                            <span className="text-gray-400 text-sm flex items-center gap-1">
                                            <FileText className="w-4 h-4" />
                                            Not uploaded
                                            </span>
                                        )}
                                    </div>

                                    {isEditMode && (
                                        <>
                                            {/* Upload new button */}
                                            <label className="inline-flex items-center px-4 py-2 bg-blue-50 text-blue-700 rounded-md cursor-pointer hover:bg-blue-100 dark:bg-gray-800 dark:text-white transition-colors w-fit">
                                            <span className="text-sm font-medium">Upload New</span>
                                            <input
                                                type="file"
                                                className="hidden"
                                                accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                                                ref={(el) => {
                                                if (el) fileInputRefs.current[`documents_${docKey}`] = el;
                                                }}
                                                onChange={(e) =>
                                                setSelectedSubmission((prev) => ({
                                                    ...prev,
                                                    documents: {
                                                    ...prev.documents,
                                                    [docKey]: {
                                                        ...prev.documents[docKey],
                                                        file: e.target.files[0],
                                                    },
                                                    },
                                                }))
                                                }
                                            />
                                            </label>
                                        </>
                                    )}

                                    {/* ✅ Show selected file name */}
                                    {docValue?.file && (
                                    <span className="text-sm text-green-600 mt-1">
                                        Selected file: <span className="font-medium">{docValue.file.name}</span>
                                    </span>
                                    )}
                                </div>
                                ))}
                                </div>
                            )}
                            </div>
                        </div>
                        )}

                        {/* Education Tab */}
                        {activeTab === 'education' && (
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-white">Educational Documents</h3>
                            <div className="bg-white dark:bg-black dark:border-gray-700  p-6 rounded-lg shadow-sm border border-gray-200">
                            {selectedSubmission?.educational_documents && typeof selectedSubmission?.educational_documents === 'object' && (
                                <div className="grid grid-cols-1 gap-6">
                                {Object.entries(selectedSubmission?.educational_documents).map(([docKey, docValue]) => (
                                    <div key={docKey} className="flex flex-col gap-2 p-4 dark:border-gray-700 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors">
                                    <label className="text-gray-700 capitalize font-medium dark:text-white">
                                        {docKey.replace(/_/g, ' ')}:
                                    </label>
                                    <div className="flex items-center gap-4">
                                        {docValue?.preview_url ? (
                                        // <a
                                        //     href={docValue.preview_url}
                                        //     target="_blank"
                                        //     rel="noopener noreferrer"
                                        //     className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                        // >
                                        //     <FileText className="w-4 h-4" />
                                        //     View current file
                                        // </a>
                                        <button
                                            onClick={() => {
                                            setPreviewUrl(docValue.preview_url);
                                            setDownloadUrl(docValue);
                                            setIsPreviewOpen(true);
                                            }}
                                            className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                        >
                                            <FileText className="w-4 h-4" />
                                            View current file
                                        </button>
                                        ) : (
                                        <span className="text-gray-400 text-sm flex items-center gap-1">
                                            <FileText className="w-4 h-4" />
                                            Not uploaded
                                        </span>
                                        )}
                                    </div>

                                    {isEditMode && (
                                        <label className="inline-flex items-center px-4 py-2 bg-blue-50 text-blue-700 rounded-md cursor-pointer hover:bg-blue-100 dark:bg-gray-800 dark:text-white transition-colors w-fit">
                                            <span className="text-sm font-medium">Upload New</span>
                                            <input
                                            type="file"
                                            className="hidden"
                                            accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                                            ref={(el) => {
                                                if (el) fileInputRefs.current[`educational_documents_${docKey}`] = el;
                                            }}
                                            onChange={(e) =>
                                                setSelectedSubmission((prev) => ({
                                                ...prev,
                                                educational_documents: {
                                                    ...prev.educational_documents,
                                                    [docKey]: {
                                                    ...prev.educational_documents[docKey],
                                                    file: e.target.files[0],
                                                    },
                                                },
                                                }))
                                            }
                                            />
                                        </label>
                                    )}

                                    {/* ✅ Show selected file name */}
                                    {docValue?.file && (
                                    <span className="text-sm text-green-600 mt-1">
                                        Selected file: <span className="font-medium">{docValue.file.name}</span>
                                    </span>
                                    )}
                                    </div>
                                ))}
                                </div>
                            )}
                            </div>
                        </div>
                        )}

                        {/* Bank Details Tab */}
                        {activeTab === 'bankDetails' && (
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-white">Bank Details</h3>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {[
                                { key: 'account_number', label: 'Account Number', required: true },
                                { key: 'ifsc_code', label: 'IFSC Code', required: true },
                            ].map(({ key, label, required }) => (
                                <div className="flex flex-col gap-1" key={key}>
                                <label className="text-gray-600 text-sm font-medium dark:text-white">
                                    {label}
                                    {required && <span className="text-red-500 ml-1">*</span>}
                                </label>

                                {isEditMode ? (
                                    <input
                                        type="text"
                                        className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                                        fieldErrors[key]
                                            ? 'border-red-500 focus:ring-red-400'
                                            : 'focus:ring-blue-500'
                                        }`}
                                        value={selectedSubmission[key] || ''}
                                        onChange={(e) =>
                                        setSelectedSubmission((prev) => ({
                                            ...prev,
                                            [key]: e.target.value,
                                        }))
                                        }
                                        onBlur={(e) => {
                                        let value = e.target.value.trim();
                                        let error = '';

                                        if (!value) {
                                            error = `${label} is required`;
                                        } else {
                                            if (key === 'account_number') {
                                            if (!/^\d{9,18}$/.test(value)) {
                                                error = 'Account Number must be 9 to 18 digits';
                                            }
                                            } else if (key === 'ifsc_code') {
                                            value = value.toUpperCase(); // Normalize
                                            if (!/^[A-Za-z0-9]+$/.test(value)) {
                                                error = 'IFSC Code must be alphanumeric (A-Z, 0-9)';
                                            }
                                            }
                                        }

                                        setFieldErrors((prev) => ({ ...prev, [key]: error }));
                                        setSelectedSubmission((prev) => ({ ...prev, [key]: value }));
                                        }}
                                    />
                                ) : (
                                <div className="px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200">
                                    {selectedSubmission[key] || '-'}
                                </div>   
                                )}
                                {fieldErrors[key] && (
                                    <span className="text-sm text-red-500">{fieldErrors[key]}</span>
                                )}
                                </div>
                            ))}
                            </div>

                            {/* bank ducuments */}
                            <div className="bg-white dark:bg-black dark:border-gray-700 p-6 rounded-lg shadow-sm border border-gray-200">
                            <h4 className="font-medium mb-4 text-gray-700 dark:text-white">Bank Documents</h4>
                            {selectedSubmission?.bank_details && typeof selectedSubmission?.bank_details === 'object' && (
                                <div className="grid grid-cols-1 gap-6">
                                {Object.entries(selectedSubmission?.bank_details).map(([docKey, docValue]) => (
                                    <div key={docKey} className="flex flex-col gap-2 p-4 border dark:border-gray-700 dark:hover:bg-gray-900 rounded-lg hover:bg-gray-50 transition-colors">
                                    <label className="text-gray-700 capitalize font-medium dark:text-white">
                                        {docKey.replace(/_/g, ' ')}:
                                    </label>
                                    <div className="flex items-center gap-4">
                                        {docValue?.preview_url ? (
                                        // <a
                                        //     href={docValue.preview_url}
                                        //     target="_blank"
                                        //     rel="noopener noreferrer"
                                        //     className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                        // >
                                        //     <FileText className="w-4 h-4" />
                                        //     View current file
                                        // </a>
                                        <button
                                            onClick={() => {
                                            setPreviewUrl(docValue.preview_url);
                                            setDownloadUrl(docValue);
                                            setIsPreviewOpen(true);
                                            }}
                                            className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                        >
                                            <FileText className="w-4 h-4" />
                                            View current file
                                        </button>
                                        ) : (
                                        <span className="text-gray-400 text-sm flex items-center gap-1">
                                            <FileText className="w-4 h-4" />
                                            Not uploaded
                                        </span>
                                        )}
                                    </div>

                                    {isEditMode && (
                                        <label className="inline-flex items-center px-4 py-2 dark:bg-gray-800 dark:text-white bg-blue-50 text-blue-700 rounded-md cursor-pointer hover:bg-blue-100 transition-colors w-fit">
                                            <span className="text-sm font-medium">Upload New</span>
                                            <input
                                            type="file"
                                            className="hidden"
                                            accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                                            ref={(el) => {
                                                if (el) fileInputRefs.current[`bank_details_${docKey}`] = el;
                                            }}
                                            onChange={(e) =>
                                                setSelectedSubmission((prev) => ({
                                                ...prev,
                                                bank_details: {
                                                    ...prev.bank_details,
                                                    [docKey]: {
                                                    ...prev.bank_details[docKey],
                                                    file: e.target.files[0],
                                                    },
                                                },
                                                }))
                                            }
                                            />
                                        </label>
                                    )}

                                    {/* ✅ Show selected file name */}
                                    {docValue?.file && (
                                    <span className="text-sm text-green-600 mt-1">
                                        Selected file: <span className="font-medium">{docValue.file.name}</span>
                                    </span>
                                    )}
                                    </div>
                                ))}
                                </div>
                            )}
                            </div>
                        </div>
                        )}

                        {/* Additional Documents Tab */}
                        {activeTab === 'additional' && (
                        <div className="space-y-6">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-white">Additional Information</h3>
                            
                            <div className="bg-white dark:bg-black dark:border-gray-700 p-6 rounded-lg shadow-sm border border-gray-200">
                                <h4 className="font-medium mb-4 text-gray-700 dark:text-white">Additional Documents</h4>

                                    {selectedSubmission?.additional_documents && typeof selectedSubmission.additional_documents === 'object' ? (
                                        Object.values(selectedSubmission.additional_documents).every(
                                        (doc) => !doc?.preview_url && !doc?.file
                                        ) ? (
                                        <p className="text-sm text-gray-500 italic dark:text-gray-400">No Additional documents are uploaded.</p>
                                        ) : (
                                            <div className="grid grid-cols-1 gap-6">
                                            {Object.entries(selectedSubmission?.additional_documents).map(([docKey, docValue]) => (
                                                <div key={docKey} className="flex flex-col gap-2 p-4 border rounded-lg dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-900 transition-colors">
                                                <label className="text-gray-700 dark:text-white capitalize font-medium">
                                                    {docKey.replace(/_/g, ' ')}:
                                                </label>
                                                <div className="flex items-center gap-4">
                                                    {docValue?.preview_url ? (
                                                    // <a
                                                    //     href={docValue.preview_url}
                                                    //     target="_blank"
                                                    //     rel="noopener noreferrer"
                                                    //     className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                                    // >
                                                    //     <FileText className="w-4 h-4" />
                                                    //     View current file
                                                    // </a>
                                                    <button
                                                        onClick={() => {
                                                        setPreviewUrl(docValue.preview_url);
                                                        setDownloadUrl(docValue);
                                                        setIsPreviewOpen(true);
                                                        }}
                                                        className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                                    >
                                                        <FileText className="w-4 h-4" />
                                                        View current file
                                                    </button>
                                                    ) : (
                                                    <span className="text-gray-400 text-sm flex items-center gap-1">
                                                        <FileText className="w-4 h-4" />
                                                        Not uploaded
                                                    </span>
                                                    )}
                                                </div>
                                                
                                                {isEditMode && (
                                                    <label className="inline-flex items-center px-4 py-2 dark:bg-gray-800 dark:text-white bg-blue-50 text-blue-700 rounded-md cursor-pointer hover:bg-blue-100 transition-colors w-fit">
                                                        <span className="text-sm font-medium">Upload New</span>
                                                        <input
                                                        type="file"
                                                        className="hidden"
                                                        accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                                                        ref={(el) => {
                                                            if (el) fileInputRefs.current[`additional_documents_${docKey}`] = el;
                                                        }}
                                                        onChange={(e) =>
                                                            setSelectedSubmission((prev) => ({
                                                            ...prev,
                                                            additional_documents: {
                                                                ...prev.additional_documents,
                                                                [docKey]: {
                                                                ...prev.additional_documents[docKey],
                                                                file: e.target.files[0],
                                                                },
                                                            },
                                                            }))
                                                        }
                                                        />
                                                    </label>
                                                )}
                                                {/* ✅ Show selected file name */}
                                                {docValue?.file && (
                                                <span className="text-sm text-green-600 mt-1">
                                                    Selected file: <span className="font-medium">{docValue.file.name}</span>
                                                </span>
                                                )}
                                                </div>
                                            ))}
                                            </div>
                                        )
                                    ) : (
                                        <p className="text-sm text-gray-500 italic dark:text-gray-400">No additional documents available.</p>
                                    )}  

                                    {/* background verification related fields */}
                                    {selectedSubmission?.employee_type === "Experienced" && 
                                        <>
                                            <h4 className="font-medium my-6 text-gray-700 dark:text-white">Background Verification</h4>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                                {[
                                                { key: 'previous_company_name', label: 'Previous Company Name', required: true },
                                                { key: 'prev_emp_id', label: 'Previous Employee ID', required: false },
                                                { key: 'prev_designation', label: 'Previous Designation', required: true },
                                                { key: 'prev_hr_name', label: 'HR Name', required: true },
                                                { key: 'prev_hr_email', label: 'HR Email', required: true },
                                                { key: 'prev_hr_contact', label: 'HR Contact', required: true },
                                                ].map(({ key, label, readOnly, required }) => (
                                                <div className="flex flex-col gap-1" key={key}>
                                                    <label className="text-gray-600 text-sm font-medium dark:text-white">
                                                        {label}
                                                        {required && <span className="text-red-500 ml-1">*</span>}
                                                    </label>

                                                    {isEditMode ? (
                                                        <input
                                                        type="text"
                                                        required
                                                        className={`border dark:text-white dark:border-gray-700 dark:focus:outline-none dark:bg-black rounded px-3 py-2 ${
                                                            readOnly
                                                            ? 'bg-gray-100 cursor-not-allowed'
                                                            : fieldErrors[key]
                                                            ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                                            : 'focus:outline-none focus:ring-2 focus:ring-blue-500'
                                                        }`}
                                                        value={selectedSubmission[key] || ''}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (key === 'designation') {
                                                            // Allow only alphabets, spaces, and hyphens
                                                            const validText = /^[a-zA-Z\s-]*$/.test(value);
                                                            if (!validText) return;
                                                            }

                                                            setSelectedSubmission((prev) => ({
                                                            ...prev,
                                                            [key]: value,
                                                            }));
                                                        }}
                                                        onBlur={(e) => {
                                                            const value = e.target.value.trim();
                                                            let error = '';

                                                            if (key === 'designation') {
                                                            if (!value) {
                                                                error = 'Designation is required';
                                                            } else if (!/^[a-zA-Z\s-]+$/.test(value)) {
                                                                error = 'Designation can only contain letters, spaces, and hyphens';
                                                            }
                                                            }

                                                            setFieldErrors((prev) => ({
                                                            ...prev,
                                                            [key]: error,
                                                            }));

                                                            if (!readOnly) {
                                                            setSelectedSubmission((prev) => ({
                                                                ...prev,
                                                                [key]: value,
                                                            }));
                                                            }
                                                        }}
                                                        readOnly={readOnly}
                                                        disabled={readOnly}
                                                        />
                                                    ) : (
                                                    <div className="px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200">
                                                        {selectedSubmission[key] || '-'}
                                                    </div> 
                                                    )}

                                                    {fieldErrors[key] && (
                                                    <p className="text-red-500 text-sm mt-1">{fieldErrors[key]}</p>
                                                    )}
                                                </div>
                                                ))}

                                            </div>
                                        </>
                                    }
                            </div>

                            {selectedSubmission.bfl_documents && typeof selectedSubmission.bfl_documents === 'object' && (
                                <div className="bg-white dark:bg-black p-6 rounded-lg shadow-sm border dark:border-gray-700 border-gray-200">
                                    <h4 className="font-medium mb-4 text-gray-700 dark:text-white">BFL Documents</h4>
                                    {Object.values(selectedSubmission.bfl_documents).every(
                                        (doc) => !doc?.preview_url && !doc?.file
                                    ) ? (
                                        <p className="text-sm text-gray-500 italic dark:text-gray-400">No BFL documents are uploaded.</p>
                                    ) : (
                                        <div className="grid grid-cols-1 gap-6">
                                        {Object.entries(selectedSubmission.bfl_documents).map(([docKey, docValue]) => (
                                            <div key={docKey} className="flex flex-col gap-2 p-4 border rounded-lg dark:border-gray-700 dark:hover:bg-gray-900 hover:bg-gray-50 transition-colors">
                                            <label className="text-gray-700 capitalize font-medium dark:text-white">
                                                {docKey.replace(/_/g, ' ')}:
                                            </label>
                                            <div className="flex items-center gap-4">
                                                {docValue?.preview_url ? (
                                                // <a
                                                //     href={docValue.preview_url}
                                                //     target="_blank"
                                                //     rel="noopener noreferrer"
                                                //     className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                                // >
                                                //     <FileText className="w-4 h-4" />
                                                //     View current file
                                                // </a>
                                                <button
                                                    onClick={() => {
                                                    setPreviewUrl(docValue.preview_url);
                                                    setDownloadUrl(docValue);
                                                    setIsPreviewOpen(true);
                                                    }}
                                                    className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                                >
                                                    <FileText className="w-4 h-4" />
                                                    View current file
                                                </button>
                                                ) : (
                                                <span className="text-gray-400 text-sm flex items-center gap-1">
                                                    <FileText className="w-4 h-4" />
                                                    Not uploaded
                                                </span>
                                                )}
                                            </div>

                                            {isEditMode && (
                                                <label className="inline-flex items-center px-4 py-2 bg-blue-50 text-blue-700 rounded-md cursor-pointer hover:bg-blue-100 dark:bg-gray-800 dark:text-white transition-colors w-fit">
                                                    <span className="text-sm font-medium">Upload New</span>
                                                    <input
                                                    type="file"
                                                    className="hidden"
                                                    ref={(el) => {
                                                        if (el) fileInputRefs.current[`bfl_documents_${docKey}`] = el;
                                                    }}
                                                    onChange={(e) =>
                                                        setSelectedSubmission((prev) => ({
                                                        ...prev,
                                                        bfl_documents: {
                                                            ...prev.bfl_documents,
                                                            [docKey]: {
                                                            ...prev.bfl_documents[docKey],
                                                            file: e.target.files[0],
                                                            },
                                                        },
                                                        }))
                                                    }
                                                    />
                                                </label>
                                            )}

                                            {/* ✅ Show selected file name */}
                                            {docValue?.file && (
                                            <span className="text-sm text-green-600 mt-1">
                                                Selected file: <span className="font-medium">{docValue.file.name}</span>
                                            </span>
                                            )}
                                            </div>
                                        ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        )}

                        {/* extra Tab */}
                        {activeTab === 'extra' && (
                        <div className="sp  ace-y-6">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-white">Feedback Information</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {[
                                { key: 'followed_ibvl_social', label: 'Followed on IBVL Social?', required: true },
                                { key: 'feedback', label: 'Feedback', required: false },
                                { key: 'rating', label: 'Ratings', required: true },
                                ].map(({ key, label, required }) => (
                                <div className="flex flex-col gap-1" key={key}>
                                    <label className="text-gray-600 text-sm font-medium dark:text-white">
                                        {label}
                                        {required && <span className="text-red-500 ml-1">*</span>}    
                                    </label>

                                    {key === 'followed_ibvl_social' ? (
                                    isEditMode ? (
                                        <select
                                        className={`border rounded dark:text-white dark:border-gray-700 dark:bg-black px-3 py-2 focus:outline-none focus:ring-2 ${
                                            fieldErrors[key] ? 'border-red-500 focus:ring-red-400' : 'focus:ring-blue-500'
                                        }`}
                                        value={selectedSubmission[key] || ''}
                                        onChange={(e) =>
                                            setSelectedSubmission((prev) => ({ ...prev, [key]: e.target.value }))
                                        }
                                        onBlur={(e) => {
                                            const value = e.target.value.trim();
                                            let error = '';
                                            if (!value) {
                                            error = 'This field is required';
                                            } else if (!['yes', 'no'].includes(value.toLowerCase())) {
                                            error = 'Please select "yes" or "no"';
                                            }
                                            setFieldErrors((prev) => ({ ...prev, [key]: error }));
                                        }}
                                        >
                                        <option value="">Select an option</option>
                                        <option value="yes">yes</option>
                                        <option value="no">no</option>
                                        </select>
                                    ) : (
                                        <div className="px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200">
                                        {selectedSubmission[key] || '-'}
                                        </div>
                                    )
                                    ) : isEditMode ? (
                                    <input
                                        type="text"
                                        className={`border rounded dark:text-white dark:border-gray-700 dark:bg-black px-3 py-2 focus:outline-none focus:ring-2 ${
                                        fieldErrors[key] ? 'border-red-500 focus:ring-red-400' : 'focus:ring-blue-500'
                                        }`}
                                        value={selectedSubmission[key] || ''}
                                        onChange={(e) => {
                                        const value = e.target.value;
                                        if (key === 'rating') {
                                            if (/^\d*$/.test(value)) {
                                            setSelectedSubmission((prev) => ({ ...prev, [key]: value }));
                                            }
                                        } else {
                                            setSelectedSubmission((prev) => ({ ...prev, [key]: value }));
                                        }
                                        }}
                                        onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        let error = '';
                                        if (key === 'rating') {
                                            const num = parseInt(value, 10);
                                            if (!value) {
                                            error = 'Rating is required';
                                            } else if (isNaN(num) || num < 1 || num > 5) {
                                            error = 'Rating must be a number between 1 and 5';
                                            }
                                        }
                                        setFieldErrors((prev) => ({ ...prev, [key]: error }));
                                        setSelectedSubmission((prev) => ({ ...prev, [key]: value }));
                                        }}
                                    />
                                    ) : (
                                    <div className="px-3 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200">
                                        {selectedSubmission[key] || '-'}
                                    </div>
                                    )}


                                    {fieldErrors[key] && (
                                    <p className="text-red-500 text-sm">{fieldErrors[key]}</p>
                                    )}
                                </div>
                                ))}
                            </div>
                        </div>
                        )}
                    </div>

                    {/* Submit Button - Fixed at bottom */}
                    <div className="mt-8 pt-4 border-t sticky bottom-0 bg-gray-50 dark:border-gray-700 dark:bg-gray-900  p-4">
                        <div className="flex justify-end gap-2">

                        {/* show if isEditMode is not true */}
                        {!isEditMode && (
                        <>
                            <ExportToExcel data={selectedSubmission} style={"px-4 py-2 text-sm font-medium rounded-md border border-green-400 text-green-600 hover:bg-white"} fileName={`${selectedSubmission?.full_name}'s on-boarding form response`} />

                            {/* open approve modal */}
                            <button
                            onClick={() => openApprovalModal(selectedSubmission, 'approved')}
                            className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md border border-green-400 text-green-600 hover:bg-white"
                            title="Approve Submission"
                            >
                            Approve
                            </button>

                            {/* open reject modal */}
                            <button
                            onClick={() => {
                                openApprovalModal(selectedSubmission, 'rejected');
                                setOpenDropdownId(null);
                            }}
                            className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md border border-red-400 text-red-600 hover:bg-white"
                            >
                            Reject
                            </button>
                        </>
                        )}

                        {isEditMode ? (
                            <>
                            <button
                                onClick={handleUpdate}
                                className="flex items-center gap-2 px-3 py-1.5 px-4 py-2 text-sm font-medium rounded-md border border-green-400 text-green-600 hover:bg-white"
                                title="Save Changes"
                            >
                                <Save size={14} />
                                {loadingSaveChanges? "Saving..." : "Save Changes"}
                            </button>
                            <button
                                onClick={handleCancelEdit}
                                className="flex items-center gap-2 px-3 py-1.5 px-4 py-2 text-sm font-medium rounded-md border border-blue-400 text-blue-600 hover:bg-white"
                                title="Cancel Changes"
                            >
                                <X size={14} />
                                Cancel
                            </button>
                            </>
                        ) : (
                            <button
                            onClick={handleEditToggle}
                            className="flex items-center gap-2 px-3 py-1.5 px-4 py-2 text-sm font-medium rounded-md border border-blue-400 text-blue-600 hover:bg-white"
                            title="Edit Information"
                            >
                            <Edit3 size={14} />
                            Edit
                            </button>
                        )}
                        </div>
                    </div>
                </div>
                ) : (
                    ""
                )}
            </Drawer>

            {/* approve modal */}
            {isApprovalModalOpen && (
                <div className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm flex items-center justify-center font-poppins">
                    <div className="w-full max-w-5xl max-h-[90vh] h-auto bg-white dark:bg-gray-900 rounded-xl overflow-hidden shadow-xl transition-all animate-fade-in flex flex-col">

                        {/* Header */}
                        <div className="md:p-4 px-3 py-1 border-b dark:border-gray-700 bg-gradient-to-r dark:text-white">
                            <div className="flex items-center justify-between">
                                <h2 className="md:text-xl font-medium text-gray-500">
                                    {actionType === "rejected" ? "Reject Onboarding" : "Approve Onboarding"}: {" "}
                                    <span className="font-semibold truncate text-black">{selectedSubmission?.full_name}</span>
                                </h2>
                                <button 
                                onClick={closeApprovalModal}
                                className="rounded-full p-2 hover:bg-white/20 transition-colors"
                                >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                                </button>
                            </div>
                        </div>
                        
                        {/* Content */}
                        <div className="md:p-6 dark:bg-gray-900 overflow-y-auto flex-1 bg-gray-50">
                            <div className="bg-white dark:bg-gray-900 rounded-xl md:p-6 px-3 py-2 shadow-sm gap-6">

                                {/* Conditional Comments Input for Rejection */}
                                {actionType === "rejected" && (
                                    <div className="p-4">
                                        <label className="block dark:text-white text-sm font-medium text-gray-700 mb-2">
                                            Rejection Comments
                                        </label>
                                        <textarea
                                            rows={4}
                                            placeholder="Enter reason for rejection"
                                            className="w-full dark:bg-black dark:text-white dark:border-gray-700 border border-gray-300 rounded-md p-2"
                                            value={approvalComment}
                                            onChange={(e) => setApprovalComment(e.target.value)}
                                        />
                                        {errors.approvalComment && <p className="text-red-500 text-sm mt-1">{errors.approvalComment}</p>}
                                    </div>
                                )}
                                
                                {actionType != "rejected" && (
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        
                                        {/* employee is bfl  */}
                                        <div>
                                            <label htmlFor="employee_is_bfl" className="font-medium dark:text-white md:text-md text-sm text-gray-700 mb-2 inline-block">
                                                Is BFL Employee ? <span className="text-red-500">*</span>
                                            </label>
                                            <select
                                                id="employee_is_bfl"
                                                name="employee_is_bfl"
                                                value={employee_is_bfl}
                                                onChange={(e) => setEmployeeIsBFL(e.target.value)}
                                                required
                                                className="w-full dark:bg-black dark:text-white dark:border-gray-700 border border-gray-300 rounded md:py-3 px-3 py-2 "
                                            >
                                                <option value="">Select...</option>
                                                <option value="yes">Yes</option>
                                                <option value="no">No</option>
                                            </select>
                                            {errors.employee_is_bfl && <p className="text-red-500 text-sm">{errors.employee_is_bfl}</p>}
                                        </div>

                                        {/* employee id */} 
                                        <div>
                                            <label htmlFor="employee_id_by_hr" className="font-medium dark:text-white md:text-md text-sm text-gray-700 mb-2 inline-block">
                                                Employee ID <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                    <circle cx="12" cy="7" r="4"></circle>
                                                </svg>
                                                </div>
                                                <input
                                                type="text"
                                                id="employee_id_by_hr"
                                                value={employee_id_by_hr}
                                                onChange={(e) => setEmployeeIDByHr(e.target.value)}
                                                placeholder="e.g. 10000"
                                                className="pl-10 pr-4 dark:bg-black dark:text-white dark:border-gray-700 md:py-3 py-2 w-full rounded-lg border border-gray-300 transition"
                                                />
                                            </div>
                                            {errors.employee_id_by_hr && <p className="text-red-500 text-sm mt-1 mb-2">{errors.employee_id_by_hr}</p>}
                                        </div>

                                        {/* employee Process */}
                                        <div>
                                            <label htmlFor="processToJoin" className="font-medium dark:text-white md:text-md text-sm text-gray-700 mb-2 inline-block">
                                                Employee Process <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <circle cx="12" cy="12" r="3"></circle>
                                                        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.09a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.09a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
                                                    </svg>
                                                </div>
                                                <input
                                                    id="processToJoin"
                                                    type="text"
                                                    value={processToJoin}
                                                    onChange={(e) => setProcessToJoin(e.target.value)}
                                                    placeholder="e.g. BFL, Development"
                                                    className="pl-10 pr-4 dark:bg-black dark:text-white dark:border-gray-700 md:py-3 py-2 w-full rounded-lg border border-gray-300 transition"
                                                />
                                            </div>
                                            {errors.processToJoin && <p className="text-red-500 text-sm mt-1">{errors.processToJoin}</p>}
                                        </div>

                                        {/* Official Email */}
                                        <div>
                                            <label htmlFor="officialEmail" className="font-medium dark:text-white md:text-md text-sm text-gray-700 mb-2 inline-block">
                                                Official Email <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                                        <polyline points="22,6 12,13 2,6"></polyline>
                                                    </svg>
                                                </div>
                                                <input
                                                    id="officialEmail"
                                                    type="email"
                                                    value={officialEmail}
                                                    onChange={(e) => setOfficialEmail(e.target.value)}
                                                    placeholder="john.doe@theimperative.in"
                                                    className="pl-10 pr-4 dark:bg-black dark:text-white dark:border-gray-700 md:py-3 py-2 w-full rounded-lg border border-gray-300 transition"
                                                />
                                            </div>
                                            {errors.officialEmail && <p className="text-red-500 text-sm mt-1">{errors.officialEmail}</p>}
                                        </div>

                                        {/* Department */}
                                        <div >
                                            <label htmlFor="department" className="font-medium dark:text-white md:text-md text-sm text-gray-700 mb-2 inline-block">
                                                Department <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <rect x="3" y="7" width="18" height="13" rx="2" ry="2"></rect>
                                                        <path d="M16 7V4a2 2 0 0 0-4 0v3"></path>
                                                        <line x1="8" y1="10" x2="8" y2="10"></line>
                                                        <line x1="12" y1="10" x2="12" y2="10"></line>
                                                        <line x1="16" y1="10" x2="16" y2="10"></line>
                                                    </svg>
                                                </div>
                                                <input
                                                    id="department"
                                                    type="text"
                                                    value={department}
                                                    onChange={(e) => setDepartment(e.target.value)}
                                                    placeholder="e.g. IT Software"
                                                    className="pl-10 pr-4 dark:bg-black dark:text-white dark:border-gray-700 md:py-3 py-2 w-full rounded-lg border border-gray-300 transition"
                                                />
                                            </div>
                                            {errors.department && <p className="text-red-500 text-sm mt-1">{errors.department}</p>}
                                        </div>

                                        {/* Probation Period */}
                                        <div>
                                            <label htmlFor="probationPeriod" className="font-medium dark:text-white md:text-md text-sm text-gray-700 mb-2 inline-block">
                                            Probation Period (months) <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                                <line x1="3" y1="10" x2="21" y2="10"></line>
                                                </svg>
                                            </div>
                                            <input
                                                id="probationPeriod"
                                                type="number"
                                                value={probationPeriod}
                                                onChange={(e) => setProbationPeriod(e.target.value)}
                                                placeholder="e.g. 3"
                                                min={0}
                                                max={3}
                                                className="pl-10 pr-4 dark:bg-black dark:text-white dark:border-gray-700 md:py-3 py-2 w-full rounded-lg border border-gray-300 transition"
                                            />
                                            </div>
                                            {errors.probationPeriod && <p className="text-red-500 text-sm mt-1">{errors.probationPeriod}</p>}
                                        </div>

                                        {/* Notice Period */}
                                        <div>
                                            <label htmlFor="noticePeriod" className="font-medium dark:text-white md:text-md text-sm text-gray-700 mb-2 inline-block">
                                            Notice Period (days)<span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <circle cx="12" cy="12" r="10"></circle>
                                                <polyline points="12 6 12 12 16 14"></polyline>
                                                </svg>
                                            </div>
                                            <input
                                                id="noticePeriod"
                                                type="number"
                                                value={noticePeriod}
                                                onChange={(e) => setNoticePeriod(e.target.value)}
                                                placeholder="e.g. 30"
                                                min={0}
                                                max={90}
                                                className="pl-10 pr-4 dark:bg-black dark:text-white dark:border-gray-700 md:py-3 py-2 w-full rounded-lg border border-gray-300 transition"
                                            />
                                            </div>
                                            {errors.noticePeriod && <p className="text-red-500 text-sm mt-1">{errors.noticePeriod}</p>}
                                        </div>

                                        {/* Reporting To - Full Width */}
                                        <div>
                                            <label htmlFor="reportingTo" className="font-medium dark:text-white md:text-md text-sm text-gray-700 mb-2 inline-block">
                                                Reporting To <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <path d="M20 21v-2a4 4 0 0 0-3-3.87"></path>
                                                        <path d="M4 21v-2a4 4 0 0 1 3-3.87"></path>
                                                        <circle cx="12" cy="7" r="4"></circle>
                                                    </svg>
                                                </div>
                                                <input
                                                    id="reportingTo"
                                                    type="text"
                                                    value={reportingTo}
                                                    onChange={(e) => setReportingTo(e.target.value)}
                                                    placeholder="e.g. John Doe"
                                                    className="pl-10 pr-4 dark:bg-black dark:text-white dark:border-gray-700 md:py-3 py-2 w-full rounded-lg border border-gray-300 transition"
                                                />
                                            </div>
                                            {errors.reportingTo && <p className="text-red-500 text-sm mt-1">{errors.reportingTo}</p>}
                                        </div>

                                    </div>
                                )}
                                
                                {actionType != "rejected" && (
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                                        <div className="w-full">
                                            <label htmlFor="approvalComment" className="font-medium dark:text-white md:text-md text-sm text-gray-700 mb-2 inline-block">
                                                Comments <span className="text-red-500">*</span>
                                            </label>
                                            <div className="relative">
                                                <div className="absolute top-3 left-3 text-gray-500">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                                                </svg>
                                                </div>
                                                <textarea
                                                id="approvalComment"
                                                value={approvalComment}
                                                onChange={(e) => setApprovalComment(e.target.value)}
                                                placeholder="Add any comments about this approval..."
                                                className="pl-10 pr-4 dark:bg-black dark:text-white dark:border-gray-700 md:py-3 py-2 w-full placeholder:text-sm rounded-lg border border-gray-300 transition h-32 resize-none"
                                                />
                                            </div>
                                            {errors.approvalComment && <p className="text-red-500 text-sm mt-1">{errors.approvalComment}</p>}
                                        </div>

                                        {/* employee offer letter */}
                                        <div 
                                            className="relative group"
                                            >

                                            <label 
                                                htmlFor="employee_offer_letter"
                                                className="flex flex-col cursor-pointer"
                                            >
                                                <div className="mb-3 text-left">
                                                    <span className="font-medium text-gray-700 dark:text-white">Employee Offer Letter</span>
                                                    <span className="text-red-500 ml-1">*</span>
                                                </div>
                                                
                                                <div className="w-full p-6 bg-gray-50 dark:bg-black rounded-md border hover:border-blue-500 flex items-center justify-center border border-dashed border-gray-300 mb-2 group-hover:border-blue-400 transition-all">
                                                {employeeOfferLetter && employeeOfferLetter[0] ? (
                                                    <div className="flex items-center text-green-600">
                                                        <CheckCircle className="w-5 h-5 mr-2" />
                                                        <span className="text-sm">File uploaded</span>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col items-center text-gray-500 group-hover:text-blue-600">
                                                        <Upload className="w-8 h-8 mb-1" />
                                                        <span className="text-sm">Upload file</span>
                                                        <small className='text-gray-500 text-center'>pdf, jpeg, jpg, png, doc, docx Allowed Max 1 MB.</small>
                                                    </div>
                                                )}
                                                </div>

                                                <input
                                                    id="employee_offer_letter"
                                                    type="file"
                                                    accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                                                    onChange={(e) => {
                                                        const allowedTypes = [
                                                        'application/pdf',
                                                        'image/jpeg',
                                                        'image/png',
                                                        'application/msword', // .doc
                                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
                                                        ];

                                                        const file = e.target.files?.[0];

                                                        if (!file) return;

                                                        // ✅ Check file type
                                                        if (!allowedTypes.includes(file.type)) {
                                                        alert('Only PDF, JPEG, JPG, PNG, DOC, and DOCX files are allowed.');
                                                        e.target.value = ''; // Clear the invalid file
                                                        return;
                                                        }

                                                        // ✅ Check file size (5 MB = 5 * 1024 * 1024 bytes)
                                                        const maxSizeInBytes = 5 * 1024 * 1024;
                                                        if (file.size > maxSizeInBytes) {
                                                        alert('File size must be less than or equal to 5 MB.');
                                                        e.target.value = ''; // Clear the oversized file
                                                        return;
                                                        }

                                                        setEmployeeOfferLetter(e.target.files); // Valid file
                                                    }}
                                                    className="hidden"
                                                />

                                                {employeeOfferLetter && employeeOfferLetter[0] && (
                                                <span className="text-xs text-gray-500 truncate max-w-full">
                                                    {employeeOfferLetter[0].name}
                                                </span>
                                                )}
                                            </label>
                                        
                                            {errors.employeeOfferLetter && (
                                                <div className="flex items-center text-red-500 text-sm ">
                                                {/* <AlertCircle className="w-4 h-4 mr-1" /> */}
                                                <p>{errors.employeeOfferLetter}</p>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                )}

                                {employee_is_bfl === 'yes' && actionType != "rejected" &&  (
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 py-4">
                                        
                                        {documents.map((doc) => (
                                            <div 
                                                key={doc.id} 
                                                className="relative group border border-gray-200 dark:border-gray-700 rounded-lg p-4 hover:border-blue-500 transition-all"
                                                >
                                                <label 
                                                    htmlFor={doc.id} 
                                                    className="flex flex-col items-center justify-center cursor-pointer"
                                                >
                                                    <div className="mb-2 text-center">
                                                    <span className="font-medium text-gray-700 dark:text-white">{doc.label}</span>
                                                    <span className="text-red-500 ml-1">*</span>
                                                    </div>
                                                    
                                                    <div className="w-full h-28 p-1 bg-gray-50 dark:bg-black dark:border-gray-700 rounded-md flex items-center justify-center border border-dashed border-gray-300 mb-2 group-hover:border-blue-400 transition-all">
                                                    {doc.state ? (
                                                        <div className="flex items-center text-green-600">
                                                        <CheckCircle className="w-5 h-5 mr-2" />
                                                        <span className="text-sm">File uploaded</span>
                                                        </div>
                                                    ) : (
                                                        <div className="flex flex-col items-center text-gray-500 group-hover:text-blue-600">
                                                        <Upload className="w-8 h-8 mb-1" />
                                                        <span className="text-sm">Upload file</span>
                                                        <small className='text-gray-500'>pdf, jpeg, jpg, png, doc, docx Allowed. Max 5 MB.</small>
                                                        </div>
                                                    )}
                                                    </div>
                                                    
                                                    <input
                                                        id={doc.id}
                                                        type="file"
                                                        accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                                                        onChange={handleFileChange(doc.setState)}
                                                        className="hidden"
                                                    />
                                                    
                                                    {doc.state && (
                                                    <span className="text-xs text-gray-500 truncate max-w-full">
                                                        {doc.state[0]?.name || "File selected"}
                                                    </span>
                                                    )}
                                                </label>
                                            
                                                {doc.error && (
                                                    <div className="flex items-center text-red-500 text-sm mt-2">
                                                    <AlertCircle className="w-4 h-4 mr-1" />
                                                    <p>{doc.error}</p>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}
                                
                                {employee_is_bfl !== 'yes' && actionType != "rejected" &&  (
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-4">

                                        {/* NDA */}
                                        <div className="relative group">
                                            <label 
                                                htmlFor="nda"
                                                className="flex flex-col cursor-pointer">
                                                <div className="mb-3 text-left">
                                                    <span className="font-medium text-gray-700 dark:text-white">NDA</span>
                                                    <span className="text-red-500 ml-1">*</span>
                                                </div>
                                                
                                                <div className="w-full p-6 bg-gray-50 dark:bg-black rounded-md border hover:border-blue-500 flex items-center justify-center border border-dashed border-gray-300 mb-2 group-hover:border-blue-400 transition-all">
                                                {nda && nda[0] ? (
                                                    <div className="flex items-center text-green-600">
                                                        <CheckCircle className="w-5 h-5 mr-2" />
                                                        <span className="text-sm">File uploaded</span>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col items-center text-gray-500 group-hover:text-blue-600">
                                                        <Upload className="w-8 h-8 mb-1" />
                                                        <span className="text-sm">Upload file</span>
                                                        <small className='text-gray-500 text-center'>pdf, jpeg, jpg, png, doc, docx Allowed Max 1 MB.</small>
                                                    </div>
                                                )}
                                                </div>

                                                <input
                                                    id="nda"
                                                    type="file"
                                                    accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                                                    onChange={(e) => {
                                                        const allowedTypes = [
                                                        'application/pdf',
                                                        'image/jpeg',
                                                        'image/png',
                                                        'application/msword', // .doc
                                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
                                                        ];

                                                        const file = e.target.files?.[0];

                                                        if (!file) return;

                                                        // Check file type
                                                        if (!allowedTypes.includes(file.type)) {
                                                        alert('Only PDF, JPEG, JPG, PNG, DOC, and DOCX files are allowed.');
                                                        e.target.value = ''; // Clear the invalid file
                                                        return;
                                                        }

                                                        // Check file size (5 MB = 10 * 1024 * 1024 bytes)
                                                        const maxSizeInBytes = 5 * 1024 * 1024;
                                                        if (file.size > maxSizeInBytes) {
                                                        alert('File size must be less than or equal to 1 MB.');
                                                        e.target.value = ''; // Clear the oversized file
                                                        return;
                                                        }

                                                        setNda(e.target.files); // Valid file
                                                    }}
                                                    className="hidden"
                                                />

                                                {nda && nda[0] && (
                                                <span className="text-xs text-gray-500 truncate max-w-full">
                                                    {nda[0].name}
                                                </span>
                                                )}
                                            </label>
                                            {errors.nda && (
                                                <div className="flex items-center text-red-500 text-sm ">
                                                {/* <AlertCircle className="w-4 h-4 mr-1" /> */}
                                                <p>{errors.nda}</p>
                                                </div>
                                            )}
                                        </div>

                                        {/* Other Documents */}
                                        <div className="relative group">
                                            <label 
                                                htmlFor="other_documents"
                                                className="flex flex-col cursor-pointer">
                                                <div className="mb-3 text-left">
                                                    <span className="font-medium text-gray-700 dark:text-white">Any Other Documents</span>
                                                    <span className="text-xs text-gray-500 ml-1">(Optional)</span>
                                                </div>
                                                
                                                <div className="w-full p-6 bg-gray-50 dark:bg-black rounded-md border hover:border-blue-500 flex items-center justify-center border border-dashed border-gray-300 mb-2 group-hover:border-blue-400 transition-all">
                                                {anyOtherDocuments && anyOtherDocuments.length > 0 ? (
                                                    <div className="flex items-center text-green-600">
                                                        <CheckCircle className="w-5 h-5 mr-2" />
                                                        <span className="text-sm">{anyOtherDocuments.length} file{anyOtherDocuments.length > 1 ? 's' : ''} uploaded</span>
                                                    </div>
                                                ) : (
                                                    <div className="flex flex-col items-center text-gray-500 group-hover:text-blue-600">
                                                        <Upload className="w-8 h-8 mb-1" />
                                                        <span className="text-sm">Upload files</span>
                                                        <small className='text-gray-500 text-center'>pdf, jpeg, jpg, png, doc, docx Allowed Max 1 MB each.</small>
                                                        <small className='text-gray-500 text-center'>You can select multiple files at once.</small>
                                                    </div>
                                                )}
                                                </div>

                                                <input
                                                    id="other_documents"
                                                    type="file"
                                                    accept=".pdf,.jpeg,.jpg,.png,.doc,.docx"
                                                    multiple
                                                    onChange={(e) => {
                                                        const allowedTypes = [
                                                        'application/pdf',
                                                        'image/jpeg',
                                                        'image/png',
                                                        'application/msword', // .doc
                                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
                                                        ];

                                                        const files = Array.from(e.target.files || []);

                                                        if (files.length === 0) return;

                                                        // Check each file
                                                        for (const file of files) {
                                                            // Check file type
                                                            if (!allowedTypes.includes(file.type)) {
                                                                alert(`File "${file.name}" is not allowed. Only PDF, JPEG, JPG, PNG, DOC, and DOCX files are allowed.`);
                                                                e.target.value = ''; // Clear the invalid files
                                                                return;
                                                            }

                                                            // Check file size (1 MB = 1 * 1024 * 1024 bytes)
                                                            const maxSizeInBytes = 1 * 1024 * 1024;
                                                            if (file.size > maxSizeInBytes) {
                                                                alert(`File "${file.name}" is too large. File size must be less than or equal to 5 MB.`);
                                                                e.target.value = ''; // Clear the oversized files
                                                                return;
                                                            }
                                                        }

                                                        setAnyOtherDocuments(files); // Valid files
                                                    }}
                                                    className="hidden"
                                                />

                                                {anyOtherDocuments && anyOtherDocuments.length > 0 && (
                                                <div className="text-xs text-gray-500">
                                                    {anyOtherDocuments.map((file, index) => (
                                                        <div key={index} className="truncate max-w-full">
                                                            {file.name}
                                                        </div>
                                                    ))}
                                                </div>
                                                )}
                                            </label>
                                            {errors.anyOtherDocuments && (
                                                <div className="flex items-center text-red-500 text-sm ">
                                                <p>{errors.anyOtherDocuments}</p>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                )}

                            </div>
                        </div>
                        
                        {/* Footer */}
                        <div className="p-4 dark:bg-gray-900 dark:border-gray-700 bg-white border-t border-gray-200 flex md:justify-end justify-between gap-2">
                            <button
                                onClick={closeApprovalModal}
                                className="px-6 py-3 dark:text-white dark:border-gray-700 dark:bg-black border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-200 font-medium transition">
                                Cancel
                            </button>
                            <button
                                onClick={handleApproval}
                                disabled={isSubmitting} 
                                className="px-6 py-3 bg-gradient-to-r border border-gray-300 hover:bg-gray-200 dark:hover:bg-gray-800 dark:border-gray-700 dark:text-white rounded-lg hover:opacity-90 font-medium transition-opacity disabled:opacity-70"
                            >
                                {isSubmitting ? (
                                <span className="flex items-center">
                                    <svg
                                    className="animate-spin -ml-1 mr-2 h-4 w-4 dark:text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                    </svg>
                                    Processing...
                                </span>
                                ) : (
                                actionType === "approved" ? "Approve" : 
                                actionType === "rejected" ? "Reject" : 
                                "Submit"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* view approver details modal */}
            {isApproverModalOpen && approverDetails && (
            <div className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm flex items-center justify-center font-poppins">
                <div className="w-full max-w-5xl max-h-[90vh] h-auto bg-white dark:bg-gray-900 rounded-xl overflow-hidden shadow-xl transition-all animate-fade-in flex flex-col">
                    <div className="sticky z-10 bg-white dark:bg-gray-900 dark:border-gray-700 px-6 py-4 flex justify-between items-center border-b ">
                        <h2 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                            </svg>
                            Approval Summary
                        </h2>
                        <button
                        onClick={() => setIsApproverModalOpen(false)}
                        className="text-gray-400 hover:text-gray-700 rounded-full p-1 hover:bg-gray-100 transition-all"
                        aria-label="Close modal"
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        </button>
                    </div>

                    <div className="p-6 overflow-y-auto flex-1 dark:bg-gray-950">
                        <div className="space-y-6">
                        {/* Approver Details Section */}
                        <section>
                            <div className="flex items-center gap-2 mb-4">
                            <div className="bg-blue-100 dark:bg-blue-900 p-1 rounded">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 dark:text-blue-300" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 005 16a.5.5 0 01-.5-.5v-1a3 3 0 013-3h8a3 3 0 013 3v1a.5.5 0 01-.5.5 5.986 5.986 0 00-1.454-3.084A5 5 0 0010 11z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white">Approver Details</h3>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Approved By</p>
                                <p className="font-medium text-gray-900 dark:text-white">{approverDetails?.approved_by || "-"}</p>
                            </div>
                            
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Approver's Designation</p>
                                <p className="font-medium text-gray-900 dark:text-white">{approverDetails?.approver_designation || "-"}</p>
                            </div>
                            
                            <div className="space-y-1 md:col-span-2">
                                <p className="text-sm font-medium text-gray-500 ">Comment</p>
                                <p className="font-medium text-gray-900 dark:text-white bg-gray-50 dark:bg-black dark:border dark:border-gray-700 p-2 rounded">
                                {approverDetails?.hr_comments || "-"}
                                </p>
                            </div>
                            
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500">Actioned At</p>
                                <p className="font-medium text-gray-900 dark:text-white">
                                    {approverDetails?.actioned_at
                                    ? new Date(approverDetails?.actioned_at).toLocaleString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                        hour12: true,
                                        })
                                    : "-"}
                                </p>
                            </div>

                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Action Day</p>
                                <p className="font-medium text-gray-900 dark:text-white">{approverDetails?.action_day || "-"}</p>
                            </div>
                            </div>
                        </section>
                        
                        <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                        
                        {/* Employment Info Section */}
                        <section>
                            <div className="flex items-center gap-2 mb-4">
                            <div className="bg-purple-100  p-1 rounded">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600 " viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z" clipRule="evenodd" />
                                <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white">Official Employment Information</h3>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Employee ID</p>
                                <p className="font-medium text-gray-900 dark:text-white">{approverDetails?.employee_id_by_hr || "-"}</p>
                            </div>
                            
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Official Email</p>
                                <p className="font-medium text-gray-900 dark:text-white truncate">{approverDetails?.employee_official_email || "-"}</p>
                            </div>
                            
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Department</p>
                                <p className="font-medium text-gray-900 dark:text-white">{approverDetails?.employee_department || "-"}</p>
                            </div>
                            
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Process</p>
                                <p className="font-medium text-gray-900 dark:text-white">{approverDetails?.employee_process || "-"}</p>
                            </div>
                            
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 400">Probation Period</p>
                                <p className="font-medium text-gray-900 dark:text-white">{approverDetails?.employee_probation_period || "-"}</p>
                            </div>
                            
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Notice Period</p>
                                <p className="font-medium text-gray-900 dark:text-white">{approverDetails?.employee_notice_period || "-"}</p>
                            </div>
                            
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Reporting To</p>
                                <p className="font-medium text-gray-900 dark:text-white">{approverDetails?.employee_reporting_to || "-"}</p>
                            </div>
                            
                            <div className="space-y-1">
                                <p className="text-sm font-medium text-gray-500 ">Offer Letter</p>
                                {approverDetails?.employee_offer_letter?.preview_url ? (
                                // <a
                                //     href={approverDetails?.employee_offer_letter?.preview_url}
                                //     target="_blank"
                                //     rel="noopener noreferrer"
                                //     className="inline-flex items-center text-blue-600 hover:underline hover:underline-offset-4 truncate max-w-full"
                                //     title={approverDetails?.employee_offer_letter?.original_name}
                                // >
                                //     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                //     <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                                //     </svg>
                                //     <span className="truncate">{approverDetails?.employee_offer_letter?.original_name}</span>
                                // </a>
                                <button
                                    onClick={() => {
                                    setPreviewUrl(approverDetails?.employee_offer_letter?.preview_url);
                                    setDownloadUrl(approverDetails?.employee_offer_letter);
                                    setIsPreviewOpen(true);
                                    }}
                                    className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                >
                                    <FileText className="w-4 h-4" />
                                    {approverDetails?.employee_offer_letter?.original_name}
                                </button>
                                ) : (
                                <p className="font-medium text-gray-500 ">No document available</p>
                                )}
                            </div>
                            </div>
                        </section>
                        
                        {/* BFL Documents Section */}
                        {approverDetails?.bfl_documents &&
                            Object.values(approverDetails?.bfl_documents).some(doc => doc?.preview_url) && (
                            <>
                            <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                            
                            <section>
                                <div className="flex items-center gap-2 mb-4">
                                <div className="bg-amber-100 dark:bg-amber-900 p-1 rounded">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-amber-600 dark:text-amber-300" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <h3 className="text-lg font-medium text-gray-900 dark:text-white">BFL Documents</h3>
                                </div>
                                
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                {Object.entries(approverDetails?.bfl_documents).map(([key, doc]) => (
                                    key === 'other_documents' && Array.isArray(doc) ? null : (
                                        doc?.preview_url && (
                                            <div 
                                                key={key} 
                                                className="flex items-start p-3 rounded-lg border border-gray-200 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-900 transition-colors"
                                            >
                                                <div className="bg-gray-100 dark:bg-gray-900 p-2 rounded mr-3">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                                </svg>
                                                </div>
                                                <div className="flex-1 min-w-0">
                                                <p className="text-sm font-medium text-gray-700 capitalize mb-1 dark:text-white">
                                                    {key.replace(/_/g, ' ')}
                                                </p>
                                                {/* <a
                                                    href={doc?.preview_url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 text-sm hover:underline hover:underline-offset-4 truncate block"
                                                    title={doc?.original_name}
                                                >
                                                    {doc?.original_name}
                                                </a> */}
                                                <button
                                                    onClick={() => {
                                                    setPreviewUrl(doc?.preview_url);
                                                    setDownloadUrl(doc);
                                                    setIsPreviewOpen(true);
                                                    }}
                                                    className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                                >
                                                    <FileText className="w-4 h-4" />
                                                    {doc?.original_name}
                                                </button>
                                                </div>
                                            </div>
                                        )
                                    )
                                ))}
                                {/* Show other_documents if present */}
                                {Array.isArray(approverDetails?.bfl_documents?.other_documents) && approverDetails.bfl_documents.other_documents.length > 0 && approverDetails.bfl_documents.other_documents.map((doc, idx) => (
                                    <div 
                                        key={doc.download_url || doc.preview_url || doc.original_name || idx} 
                                        className="flex items-start p-3 rounded-lg border border-gray-200 hover:bg-gray-50 dark:border-gray-700 dark:hover:bg-gray-900 transition-colors"
                                    >
                                        <div className="bg-gray-100 dark:bg-gray-900 p-2 rounded mr-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                        </svg>
                                        </div>
                                        <div className="flex-1 min-w-0">
                                        <p className="text-sm font-medium text-gray-700 capitalize mb-1 dark:text-white">
                                            Other Document
                                        </p>
                                        {/* <a
                                            href={doc?.preview_url || doc?.download_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 text-sm hover:underline hover:underline-offset-4 truncate block"
                                            title={doc?.original_name}
                                        >
                                            {doc?.original_name}
                                        </a> */}
                                        <button
                                            onClick={() => {
                                            setPreviewUrl(doc?.preview_url);
                                            setDownloadUrl(doc);
                                            setIsPreviewOpen(true);
                                            }}
                                            className="text-blue-600 hover:text-blue-800 flex items-center gap-1 text-sm"
                                        >
                                            <FileText className="w-4 h-4" />
                                            {doc?.original_name}
                                        </button>
                                        </div>
                                    </div>
                                ))}
                                </div>
                            </section>
                            </>
                        )}
                        </div>
                    </div>

                    <div className="sticky bottom-0 z-10 bg-gray-50 dark:bg-gray-900 dark:border-gray-700 border-t px-6 py-4 flex justify-end">
                        <button
                        onClick={() => setIsApproverModalOpen(false)}
                        className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 text-white font-medium transition-colors"
                        >
                        Close
                        </button>
                    </div>
                </div>
            </div>
            )}
            
            {/* hr comment modal */}
            {openCommentId && commentSubmission && (
            <>
                {/* Background Overlay */}
                <div
                className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm z-40"
                onClick={() => setOpenCommentId(null)}
                ></div>

                {/* Modal */}
                <div
                className="fixed z-50 
                            bottom-4 left-1/2 -translate-x-1/2 
                            md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 
                            bg-white dark:bg-gray-900 rounded-lg shadow-lg p-4 
                            w-[90%] max-w-sm md:w-full md:max-w-md 
                            transition-all duration-300 ease-in-out font-poppins"
                >
                <div className="flex justify-between items-center border-b dark:border-gray-700 pb-2 mb-2">
                    <h3 className="text-sm font-semibold text-gray-700 dark:text-white">HR's Comment</h3>
                    <button onClick={() => setOpenCommentId(null)} className="text-gray-500 dark:text-white hover:text-gray-800">
                    ✕
                    </button>
                </div>
                <p className="text-sm text-gray-700 dark:text-gray-400 break-words">
                    {commentSubmission.hr_comments}
                </p>
                </div>
            </>
            )}

            {/* QR code modal */}
            <CustomModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
            >
                <div className="flex flex-col items-center gap-4 font-poppins">
                    <div className="qr-modal-svg">
                        <QRCode value={qrValue} size={160} />
                    </div>
                    <input
                    type="text"
                    readOnly
                    value={`${window.location.origin}/on-boarding/`}
                    className="border border-gray-300 dark:bg-black dark:border-gray-700 dark:focus:outline-none dark:text-white rounded px-2 py-1 text-sm w-full sm:w-64 text-gray-700 md:placeholder:text-md placeholder:text-xs"
                    />
                    <div className='flex items-center gap-2'>
                        {/* <button
                            onClick={handleDownload}
                            className="px-3 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
                            >
                            Download
                        </button> */}
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(`${window.location.origin}/on-boarding/`);
                                // setNotification("Link copied to clipboard!");
                                setNotification({
                                    message: "Link copied to clipboard!",
                                    type: "success"
                                });
                                
                            }}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm w-full sm:w-auto"
                            >
                            Copy Link
                        </button>
                        
                        <button
                            onClick={() => {
                                const printWindow = window.open('', '_blank');
                                const qrValue = `${window.location.origin}/on-boarding/`;
                                
                                // Get the QR code SVG from the modal
                                const qrModal = document.querySelector('.qr-modal-svg');
                                const svgContent = qrModal ? qrModal.outerHTML : '';
                                
                                printWindow.document.write(`
                                    <!DOCTYPE html>
                                    <html>
                                    <head>
                                        <title>QR Code - Onboarding Form</title>
                                        <style>
                                            body {
                                                font-family: Arial, sans-serif;
                                                margin: 0;
                                                padding: 20px;
                                                text-align: center;
                                            }
                                            .qr-container {
                                                display: flex;
                                                flex-direction: column;
                                                align-items: center;
                                                justify-content: center;
                                                min-height: 100vh;
                                            }
                                            .qr-title {
                                                font-size: 24px;
                                                font-weight: bold;
                                                margin-bottom: 20px;
                                                color: #333;
                                            }
                                            .qr-code {
                                                margin: 20px 0;
                                                padding: 20px;
                                                border: 2px solid #333;
                                                display: inline-block;
                                                background: white;
                                            }
                                            .qr-url {
                                                font-size: 12px;
                                                color: #666;
                                                margin-top: 10px;
                                                word-break: break-all;
                                                max-width: 300px;
                                            }
                                            @media print {
                                                body { margin: 0; }
                                                .qr-container { min-height: auto; }
                                                .qr-code { border: 2px solid #000; }
                                            }
                                        </style>
                                    </head>
                                    <body>
                                        <div class="qr-container">
                                            <div class="qr-title">Onboarding Form QR Code</div>
                                            <div class="qr-code">
                                                ${svgContent}
                                            </div>
                                            <div class="qr-url">${qrValue}</div>
                                        </div>
                                    </body>
                                    </html>
                                `);
                                
                                printWindow.document.close();
                                printWindow.focus();
                                printWindow.print();
                                printWindow.close();
                            }}
                            className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm w-full sm:w-auto flex items-center gap-1"
                            >
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                            </svg>
                            Print QR
                        </button>
                    </div>
                    <p className="text-center text-sm text-gray-600 dark:text-gray-200">
                        Scan this QR code using your mobile app.
                    </p>
                </div>
            </CustomModal>

            {/* PDF/Image Preview Modal */}
            {/* {isPreviewOpen && (
            <div className="fixed inset-0 bg-black/60 flex justify-center items-end md:items-center z-50 backdrop-blur-md transition-all duration-300">
                <div className="bg-white dark:bg-gray-900 rounded-lg shadow-lg w-11/12 md:w-3/4 lg:w-2/3 h-5/6 relative flex flex-col">
                <div className="flex justify-between items-center p-4 border-b dark:border-gray-700">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white">File Preview</h2>
                    <button
                    onClick={() => {
                        setPreviewUrl(null);
                        setIsPreviewOpen(false);
                    }}
                    className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                    >
                    <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="flex-1 overflow-hidden flex items-center justify-center">
                    {previewUrl? (
                    <iframe src={previewUrl} title="PDF Preview" className="w-full h-full" />
                    ) : (
                    <img src={previewUrl} alt="Preview" className="max-h-full max-w-full object-contain" />
                    )}
                </div>
                </div>
            </div>
            )} */}

            {/* PDF/Image Preview Modal */}
            {isPreviewOpen && (
            <div className="fixed inset-0 bg-black/60 flex justify-center items-end md:items-center z-50 backdrop-blur-md transition-all duration-300">
                <div className="bg-white dark:bg-gray-900 rounded-lg shadow-lg w-11/12 md:w-3/4 lg:w-2/3 h-5/6 relative flex flex-col">
                {/* Header */}
                <div className="flex justify-between items-center p-4 border-b dark:border-gray-700">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white">File Preview</h2>
                    <button
                    onClick={() => {
                        setPreviewUrl(null);
                        setIsPreviewOpen(false);
                    }}
                    className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                    >
                    <X className="w-5 h-5" />
                    </button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-hidden flex flex-col items-center justify-center p-4 gap-4">
                    {downloadUrl?.original_name.toLowerCase().endsWith(".pdf") ? (
                    <iframe src={previewUrl} title="PDF Preview" className="w-full h-full" />
                    ) : (
                    <div className="overflow-auto max-h-full flex flex-col items-center justify-center gap-4">   
                        <img
                        src={previewUrl}
                        alt="Preview"
                        className="max-h-full max-w-full object-contain"
                        />
                        {/* ✅ Download button for images */}
                        {downloadUrl && (
                        <a
                            href={downloadUrl?.download_url}
                            download
                            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
                        >
                            <Download className="w-4 h-4" />
                            Download
                        </a>
                        )}
                    </div>
                    )}
                </div>
                </div>
            </div>
            )}


        </div>
    );
    };

export default OnBoardingFormResponsePage;